<template>
  <div class="page-content">
    

    <v-card class="mx-auto elevation-2 tabs-card" style="margin-top: 16px;">
      <v-container fluid class="pa-2">
        <v-row align="center" justify="space-between" no-gutters>
          <v-col cols="auto">
            <v-tabs 
              v-model="activeTab" 
              class="dashboard-tab" 
              show-arrows 
              next-icon="mdi-arrow-right-bold-box-outline" 
              prev-icon="mdi-arrow-left-bold-box-outline"
              style="background-color: white; color: #2C74B3;"
            >
              <v-tab v-if="!isSatelliteMonitor" value="studio">Studio</v-tab>
              <v-tab v-if="!isSatelliteMonitor" value="morning">Morning</v-tab>
              <v-tab v-if="!isSatelliteMonitor" value="evening">Evening</v-tab>
              <v-tab v-if="!isSatelliteMonitor" value="night">Night</v-tab>

              <v-tab value="satellite">Satellite</v-tab>

              <v-tab v-if="!isSatelliteMonitor" value="active">Active</v-tab>
            </v-tabs>
          </v-col>
        </v-row>
      </v-container>
    </v-card>

    <!-- New Cards Section -->
    <v-row style="margin-top: 10px;">
      <!-- View Model Card -->
      <v-col cols="12" md="3">
        <v-card :class="['elevation-2', activeCard === 'viewModel' ? 'active-card' : '']" @click="setActiveCard('viewModel')" style="min-height: 180px; border-radius: 6px;">
          <v-card-title style="position: relative; display: flex; align-items: center; padding: 8px 16px;">
            <v-icon style="margin-right: 8px; font-size: 28px;">mdi-dance-pole</v-icon>
            <span style="position: absolute; left: 50%; transform: translateX(-50%); font-size: 16px; font-weight: 600;">View Model</span>
          </v-card-title>
          <v-card-text style="padding: 4px 16px; padding-bottom: 40px;">
            <v-select
              v-model="modelFilter"
              :items="modelFilterOptions"
              item-title="modelFilterLabel"
              item-value="fullName"
              label="Select Model"
              outlined
              hide-details
              prepend-inner-icon=""
              style="font-size: 14px;"
              :disabled="modelFilterOptions.length === 0"
            ></v-select>
          </v-card-text>
          <v-card-actions style="justify-content: center; margin-top: -16px; margin-bottom: 12px; position: absolute; bottom: 0; width: 100%;">
            <v-btn :class="['btn-secondary', activeCard === 'viewModel' ? 'active-button' : '']" style="padding: 0 40px; height: 36px; font-size: 14px; background-color: #1976d2; color: white;" @click="viewModel">View</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>

      <!-- Search Adjustments Card -->
      <v-col cols="12" md="3">
        <v-card :class="['elevation-2', activeCard === 'searchAdjustments' ? 'active-card' : '']" @click="setActiveCard('searchAdjustments')" style="min-height: 180px; border-radius: 6px;">
          <v-card-title style="position: relative; display: flex; align-items: center; padding: 8px 16px;">
            <v-icon style="margin-right: 8px; font-size: 28px;">mdi-text-box-search-outline</v-icon>
            <span style="position: absolute; left: 50%; transform: translateX(-50%); font-size: 16px; font-weight: 600;">Search Adjustments</span>
          </v-card-title>
          <v-card-text style="padding: 4px 16px; padding-bottom: 40px;">
            <v-text-field
              v-model="searchKeyword"
              label="Description"
              outlined
              hide-details
              dense
              prepend-inner-icon=""
              style="font-size: 14px;"
            />
          </v-card-text>
          <v-card-actions style="justify-content: center; margin-top: -16px; margin-bottom: 12px; position: absolute; bottom: 0; width: 100%;">
            <v-btn :class="['btn-secondary', activeCard === 'searchAdjustments' ? 'active-button' : '']" style="padding: 0 40px; height: 36px; font-size: 14px; background-color: #1976d2; color: white;" @click="searchAdjustments">Search</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>

      <!-- View Filter Card -->
      <v-col cols="12" md="3">
        <v-card :class="['elevation-2', activeCard === 'viewFilter' ? 'active-card' : '']" @click="setActiveCard('viewFilter')" style="max-height: 180px; border-radius: 6px;">
          <v-card-title style="position: relative; display: flex; align-items: center; padding: 8px 16px;">
            <v-icon style="margin-right: 8px; font-size: 28px;">mdi-filter</v-icon>
            <span style="position: absolute; left: 50%; transform: translateX(-50%); font-size: 16px; font-weight: 600;">View Filter</span>
          </v-card-title>
          <v-card-text style="padding: 4px 16px; padding-bottom: 40px;">
            <div style="display: grid; grid-template-columns: repeat(2, 1fr); gap: 8px; justify-items: center;">
              <v-chip
                v-for="filter in filterOptions"
                :key="filter"
                :color="activeFilters.includes(filter) ? '#1976d2' : '#ccc'"
                text-color="white"
                @click="toggleFilter(filter)"
                style="font-size: 14px; cursor: pointer; min-width: 120px; justify-content: center;"
              >
                {{ filter }}
              </v-chip>
            </div>
          </v-card-text>
        </v-card>
      </v-col>

      <!-- Period Card -->
      <v-col cols="12" md="3">
        <v-card :class="['elevation-2', activeCard === 'period' ? 'active-card' : '']" @click="setActiveCard('period')" style="min-height: 180px; border-radius: 6px;">
          <v-card-title style="position: relative; display: flex; align-items: center; padding: 8px 16px;">
            <v-icon style="margin-right: 8px; font-size: 28px;">mdi-calendar-multiple-check</v-icon>
            <span style="position: absolute; left: 50%; transform: translateX(-50%); font-size: 16px; font-weight: 600;">Period</span>
          </v-card-title>
          <v-card-text style="padding: 4px 16px;">
            <v-select 
              v-model="selectedPeriod" 
              :items="periods" 
              item-title="name" 
              item-value="id" 
              outlined 
              style="font-size: 14px;" 
              @update:modelValue="fetchModels"
            ></v-select>
          </v-card-text>
          <v-card-actions class="adjustments-period-actions">
            <v-btn
              icon
              class="adjustments-period-arrow"
              :disabled="!canGoToPreviousPeriod"
              aria-label="Previous period"
              @click.stop="goToPreviousPeriod"
            >
              <v-icon>mdi-chevron-left</v-icon>
            </v-btn>
            <v-btn
              icon
              class="adjustments-period-arrow"
              :disabled="!canGoToNextPeriod"
              aria-label="Next period"
              @click.stop="goToNextPeriod"
            >
              <v-icon>mdi-chevron-right</v-icon>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>

    <!-- Chips Below Cards -->
    <v-row style="margin-top: 16px;" v-if="selectedModels.length > 0">
      <v-col cols="12">
        <div style="display: flex; flex-wrap: wrap; gap: 8px;">
          <v-chip
            v-for="modelName in selectedModels"
            :key="modelName"
            closable
            @click:close="removeModelChip(modelName)"
            color="#1976d2"
            text-color="white"
            style="font-size: 14px;"
          >
            {{ modelName }}
          </v-chip>
        </div>
      </v-col>
    </v-row>

    <div
      v-if="showSkippedCbWarning"
      style="display: flex; align-items: center; gap: 10px; padding: 10px 14px; margin-top: 18px; background: #fff8e1; border: 1px solid #f4c542; border-radius: 6px; color: #7a5a00;"
    >
      <v-icon size="20" color="#c48a00">mdi-alert-outline</v-icon>
      <span style="font-size: 14px; font-weight: 500;">
        Warning: In 6-Fox-2026 and 19-Seal-2026, if Chaturbate has no sales, do not add CB adjustments in that period. Move them to the next CB payout period.
      </span>
    </div>

    <div class="excel-pending-stack">
    <section v-if="pendingLoading || pendingAdjustments.length > 0" class="pending-adjustments-section">
      <div class="pending-adjustments-header">
        <div>
          <div class="pending-adjustments-title">Pending Adjustments</div>
        </div>
        <v-chip size="small" color="orange-darken-2" variant="tonal">
          {{ pendingAdjustments.length }} pending
        </v-chip>
      </div>

      <div v-if="pendingLoading" class="pending-adjustments-empty">
        <v-progress-circular indeterminate size="22" width="2" class="mr-2" />
        Loading pending adjustments...
      </div>
      <div v-else-if="pendingAdjustments.length === 0" class="pending-adjustments-empty">
        <v-icon size="21" class="mr-2">mdi-check-circle-outline</v-icon>
        Nothing is waiting for review.
      </div>
      <div v-else class="pending-adjustments-table-wrap">
        <table class="pending-adjustments-table">
          <colgroup>
            <col class="pending-col-type" />
            <col class="pending-col-amount" />
            <col class="pending-col-currency" />
            <col class="pending-col-description" />
            <col class="pending-col-quantity" />
            <col class="pending-col-quotas" />
            <col class="pending-col-site" />
            <col class="pending-col-date" />
            <col class="pending-col-actions" />
          </colgroup>
          <tbody
            v-for="group in pendingAdjustmentGroups"
            :key="group.key"
            class="pending-adjustment-card"
          >
            <tr class="pending-model-row">
              <td colspan="9">
                <div class="pending-model-identity">
                  <div class="pending-identity-field">
                    <span class="pending-identity-field__label">Full Name</span>
                    <v-text-field
                      :model-value="pendingFullName(group.items[0])"
                      class="pending-model-select"
                      density="compact"
                      variant="outlined"
                      hide-details
                      readonly
                    />
                  </div>
                  <div class="pending-identity-field">
                    <span class="pending-identity-field__label">Stage Name</span>
                    <v-text-field
                      :model-value="pendingStageName(group.items[0]) || '—'"
                      class="pending-stage-name"
                      density="compact"
                      variant="outlined"
                      hide-details
                      readonly
                    />
                  </div>
                  <div v-if="!group.items[0].model_id && group.items[0].model_name" class="pending-original-name">
                    Report said: {{ group.items[0].model_name }}
                  </div>
                  <div v-else class="pending-review-note">
                    <span class="pending-review-note__label">Review</span>
                    <span>{{ canEdit
                      ? 'Check each item carefully, then use the arrow to move it into Adjustments'
                      : `${group.items[0].origin_type === 'cash_box' ? 'Submitted from Cash Box' : 'Submitted from Reports'} and waiting for supervisor review`
                    }}</span>
                  </div>
                  <v-btn
                    icon
                    class="btn-primary pending-approve-btn"
                    density="comfortable"
                    color="primary"
                    :title="isStudioPending(group.items[0]) ? 'Move to Studio Use' : 'Move to Adjustments'"
                    :loading="group.items.some((item) => pendingActionId === item.id)"
                    :disabled="!group.items.every((item) => canApprovePending(item)) || group.items.some((item) => pendingActionId === item.id)"
                    @click="approvePendingGroup(group)"
                  >
                    <v-icon>mdi-arrow-right</v-icon>
                  </v-btn>
                </div>
              </td>
            </tr>
            <tr class="pending-column-row">
              <th>Type</th>
              <th>Amount</th>
              <th>Xe</th>
              <th>Description</th>
              <th>Quantity</th>
              <th>Quotas</th>
              <th>Site</th>
              <th>Date</th>
              <th aria-label="Actions"></th>
            </tr>
            <tr
              v-for="(item, itemIndex) in group.items"
              :key="item.id"
              :class="['pending-fields-row', { 'pending-fields-row--last': itemIndex === group.items.length - 1 }]"
            >
              <td>
                <v-select
                  v-model="item.type"
                  :items="['Adjustment', 'Discount', 'Purchase', 'Site Bonus', 'Studio Bonus']"
                  density="compact"
                  outlined
                  hide-details
                  :disabled="!canEdit"
                />
              </td>
              <td>
                <v-text-field
                  v-model="item.amount"
                  class="pending-amount-field"
                  density="compact"
                  outlined
                  hide-details
                  autocomplete="off"
                  inputmode="decimal"
                  :disabled="!canEdit"
                  :rules="[v => /^[0-9,.]*$/.test(v) || 'Only numbers and one decimal allowed']"
                  @blur="formatAmount(item)"
                />
              </td>
              <td>
                <v-select
                  v-model="item.currency"
                  :items="currencyOptions"
                  density="compact"
                  outlined
                  hide-details
                  :disabled="!canEdit"
                />
              </td>
              <td>
                <v-text-field
                  v-model="item.description"
                  density="compact"
                  outlined
                  hide-details
                  autocomplete="off"
                  :disabled="!canEdit"
                  @update:modelValue="item.inventory_item_id = null"
                >
                  <template #append-inner>
                    <v-icon
                      v-if="item.inventory_item_id"
                      color="success"
                      size="17"
                      title="Linked to Inventory"
                    >mdi-package-variant-closed</v-icon>
                  </template>
                </v-text-field>
              </td>
              <td class="pending-quantity-cell">
                <v-combobox
                  v-if="item.type === 'Purchase'"
                  v-model="item.inventory_quantity"
                  :items="numberOptions"
                  class="pending-quantity-field"
                  density="compact"
                  outlined
                  hide-details
                  autocomplete="off"
                  inputmode="numeric"
                  :disabled="!canEdit"
                  @update:modelValue="handlePendingQuantityChange(item, $event)"
                />
                <span v-else>—</span>
              </td>
              <td>
                <v-select
                  v-model="item.quotas"
                  :items="numberOptions"
                  density="compact"
                  outlined
                  hide-details
                  :disabled="!canEdit"
                />
              </td>
              <td>
                <v-select
                  v-model="item.site"
                  :items="getPendingSiteOptions(item)"
                  item-title="menuLabel"
                  item-value="value"
                  density="compact"
                  outlined
                  hide-details
                  :disabled="!canEdit || isStudioPending(item)"
                >
                  <template #selection>
                    {{ getSiteCode(item.site) }}
                  </template>
                </v-select>
              </td>
              <td>
                <v-text-field
                  :model-value="formatPeriodDateLabel(item.report_date)"
                  density="compact"
                  outlined
                  hide-details
                  readonly
                />
              </td>
              <td class="pending-actions">
                <v-menu location="bottom end">
                  <template #activator="{ props }">
                    <v-btn
                      v-bind="props"
                      icon="mdi-dots-horizontal"
                      size="small"
                      variant="outlined"
                      class="pending-action-btn"
                      title="Review options"
                      :disabled="!canEdit || pendingActionId === item.id"
                    />
                  </template>
                  <v-list density="compact" min-width="180">
                    <v-list-item
                      prepend-icon="mdi-close"
                      title="Dismiss"
                      @click="dismissPending(item)"
                    />
                    <v-list-item
                      prepend-icon="mdi-cash-register"
                      title="Send to Direct Sales"
                      :disabled="isStudioPending(item) || item.type !== 'Purchase' || item.currency !== 'COP' || !item.inventory_item_id"
                      @click="sendPendingToDirectSales(item)"
                    />
                    <v-list-item
                      v-if="isStudioPending(item)"
                      prepend-icon="mdi-office-building-cog-outline"
                      title="Send to Studio Use"
                      :disabled="item.type !== 'Purchase' || !item.inventory_item_id"
                      @click="openStudioUseDialog(item)"
                    />
                  </v-list>
                </v-menu>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </section>

    <div class="excel-reports-block">
    <div class="excel-notes-grid">
      <v-card class="excel-note-card excel-note-card-main elevation-1">
        <div class="excel-note-header">
          <div class="excel-note-title-wrap">
            <div class="excel-note-avatar">
              <v-icon size="22">mdi-file-excel-outline</v-icon>
            </div>
            <div class="excel-note-title">Main</div>
          </div>
          <div v-if="exportStatus.main?.downloaded_at" class="excel-export-status">
            <span>Downloaded: {{ formatExportTime(exportStatus.main.downloaded_at) }}</span>
            <span v-if="exportStatus.main.updated_at">Updated: {{ formatExportTime(exportStatus.main.updated_at) }}</span>
          </div>
          <div class="excel-note-action-stack">
            <v-btn
              class="download-period-btn excel-note-download"
              variant="tonal"
              @click="downloadAdjustments('main')"
              title="Download Main Excel"
              :disabled="!selectedPeriodRecord?.payment_date"
            >
              <v-icon size="18" class="mr-1">mdi-download</v-icon>
              Download
            </v-btn>
          </div>
        </div>
        <div class="excel-note-summary-panel">
          <div class="excel-note-summary-item">
            <v-icon size="22" class="excel-note-summary-icon">mdi-calendar-month-outline</v-icon>
            <div>
              <div class="excel-note-summary-label">Payment Date</div>
              <div class="excel-note-summary-value">{{ formatPrettyDate(selectedPeriodRecord?.payment_date) || 'Not set' }}</div>
            </div>
          </div>
          <div class="excel-note-summary-divider"></div>
          <div class="excel-note-summary-item">
            <v-icon size="22" class="excel-note-summary-icon">mdi-clock-outline</v-icon>
            <div>
              <div class="excel-note-summary-label">Due in</div>
              <div
                class="excel-note-due-value"
                :class="getSendReminderClass(selectedPeriodRecord?.payment_date)"
              >
                {{ getSendReminderDaysLabel(selectedPeriodRecord?.payment_date) }}
              </div>
              <div class="excel-note-due-date">{{ getSendReminderDateLabel(selectedPeriodRecord?.payment_date) }}</div>
            </div>
          </div>
        </div>
        <div class="excel-note-divider"></div>
        <div class="excel-note-inline">
          <div class="excel-note-label">
            <v-icon size="20">mdi-note-text-outline</v-icon>
            <span>Notes</span>
          </div>
          <v-textarea
            v-model="mainExcelNote"
            placeholder="Add notes here..."
            variant="outlined"
            density="compact"
            rows="1"
            auto-grow
            max-rows="3"
            no-resize
            hide-details
            :disabled="!canEdit"
            @update:modelValue="debounceSaveExcelNotes"
          ></v-textarea>
        </div>
      </v-card>

      <v-card class="excel-note-card excel-note-card-cb elevation-1">
        <div class="excel-note-header">
          <div class="excel-note-title-wrap">
            <div class="excel-note-avatar">
              <v-icon size="22">mdi-file-excel-outline</v-icon>
            </div>
            <div class="excel-note-title">Chaturbate</div>
            <span
              v-if="pendingPreviousCbPeriod"
              class="excel-note-pending-chip"
              title="Another Chaturbate report may still need attention"
            >
              CB Pending: {{ pendingPreviousCbPeriod.name }}
            </span>
          </div>
          <div v-if="exportStatus.cb?.downloaded_at" class="excel-export-status">
            <span>Downloaded: {{ formatExportTime(exportStatus.cb.downloaded_at) }}</span>
            <span v-if="exportStatus.cb.updated_at">Updated: {{ formatExportTime(exportStatus.cb.updated_at) }}</span>
          </div>
          <div class="excel-note-action-stack">
            <v-btn
              v-if="selectedPeriodRecord?.cb_payment_date"
              class="download-period-btn excel-note-download"
              variant="tonal"
              @click="downloadAdjustments('cb')"
              title="Download Chaturbate Excel"
            >
              <v-icon size="18" class="mr-1">mdi-download</v-icon>
              Download
            </v-btn>
          </div>
        </div>
        <div class="excel-note-summary-panel">
          <div class="excel-note-summary-item">
            <v-icon size="22" class="excel-note-summary-icon">mdi-calendar-month-outline</v-icon>
            <div>
              <div class="excel-note-summary-label">Payment Date</div>
              <div class="excel-note-summary-value">{{ formatPrettyDate(selectedPeriodRecord?.cb_payment_date) || 'Not set' }}</div>
            </div>
          </div>
          <div class="excel-note-summary-divider"></div>
          <div class="excel-note-summary-item">
            <v-icon size="22" class="excel-note-summary-icon">mdi-clock-outline</v-icon>
            <div>
              <div class="excel-note-summary-label">Due in</div>
              <div
                class="excel-note-due-value"
                :class="getSendReminderClass(selectedPeriodRecord?.cb_payment_date)"
              >
                {{ getSendReminderDaysLabel(selectedPeriodRecord?.cb_payment_date) }}
              </div>
              <div class="excel-note-due-date">{{ getSendReminderDateLabel(selectedPeriodRecord?.cb_payment_date) }}</div>
            </div>
          </div>
        </div>
        <div class="excel-note-divider"></div>
        <div class="excel-note-inline">
          <div class="excel-note-label">
            <v-icon size="20">mdi-note-text-outline</v-icon>
            <span>Notes</span>
          </div>
          <v-textarea
            v-model="cbExcelNote"
            placeholder="Add notes here..."
            variant="outlined"
            density="compact"
            rows="1"
            auto-grow
            max-rows="3"
            no-resize
            hide-details
            :disabled="!canEdit"
            @update:modelValue="debounceSaveExcelNotes"
          ></v-textarea>
        </div>
      </v-card>
    </div>
    </div>
    </div>

    <!-- Divider Bar -->
    <div class="adjustments-section-bar">
      <span class="text-h6 font-weight-bold" style="font-size: 18px; font-weight: 600; color: white;">
        Adjustments
        <v-menu location="bottom">
          <template v-slot:activator="{ props }">
            <v-icon
              v-bind="props"
              size="18"
              class="ml-2"
              style="cursor: pointer;"
            >
              mdi-information-outline
            </v-icon>
          </template>
          <v-card class="pa-2" width="360">
            <div>Rules Retention:</div>
            <div class="d-flex align-center mb-2">
              <v-icon color="red" size="18" class="mr-2">mdi-alert-circle-outline</v-icon>
              Model has surpassed the annual tax threshold. Apply retention.
            </div>
            <div class="d-flex align-center">
              <v-icon color="yellow darken-2" size="18" class="mr-2">mdi-alert-circle-outline</v-icon>
              Model is nearing the annual tax threshold. Consider applying retention.
            </div>
            <v-divider class="my-2"></v-divider>
            <div>Bonus Rules:</div>
            <div class="d-flex align-start">
              <v-icon color="blue" size="18" class="mr-2 mt-1">mdi-cash-check</v-icon>
              <span>
                LiveJasmin Awards: add only the bonus difference as an Adjustment. Wiz already includes LJ awards and sales together.
                Example: $72 sales + $100 award = $172 in Wiz, paid at the model's studio rate.
                For a 50% model, the $100 award already pays $50, so add a $30 adjustment to reach the 80% award rule.
              </span>
            </div>
          </v-card>
        </v-menu>
      </span>
      <div style="display: flex; align-items: center; gap: 10px;">
        <v-menu offset-y>
          <template v-slot:activator="{ props }">
            <v-btn
              v-bind="props"
              style="text-transform: none; font-size: 1rem; background-color: transparent; color: white;"
            >
              <span style="font-weight: 400; margin-right: 4px;">Sort by:</span>
              {{ sortOption }}
              <v-icon small style="color: white;">mdi-chevron-down</v-icon>
            </v-btn>
          </template>
          <v-list dense>
            <v-list-item
              density="compact"
              v-for="option in sortOptions"
              :key="option"
              @click="sortModels(option)"
            >
              <v-list-item-title>{{ option }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </div>
    </div>

    <v-container fluid class="pa-0 mt-4">
      <v-row v-if="models.length !== 0">
        <v-col v-for="(model, modelIndex) in filteredModels" :key="model.id" cols="12">
          <!-- Existing model card content remains unchanged -->
          <v-card
            class="elevation-3"
            :style="{
              borderRadius: '6px',
              padding: 0,
              marginBottom: '16px',
              opacity: model.isLocked ? 0.5 : 1,
              pointerEvents: model.isLocked ? 'none' : 'auto'
            }"
          >
            <v-container fluid class="pa-2" style="padding: 5px 5px 5px 5px !important;">
              <v-row no-gutters align="center" dense style="margin-top: 4px; margin-bottom: 0 !important;">
                <v-col cols="4">
                  <v-text-field
                    v-model="model.fullName"
                    variant="outlined"
                    persistent-placeholder
                    label="Full Name"
                    hide-details
                    density="compact"
                    style="margin-bottom: 0 !important; height: 34px !important; font-weight: bold !important; font-size: 16px !important;"
                    readonly
                  ></v-text-field>
                </v-col>
                <v-col cols="2" class="pl-2">
                  <v-text-field
                    v-model="model.stageName"
                    variant="outlined"
                    persistent-placeholder
                    label="Stage Name"
                    hide-details
                    density="compact"
                    style="margin-bottom: 0 !important; height: 34px !important; font-weight: bold !important; font-size: 16px !important;"
                    readonly
                  ></v-text-field>
                </v-col>
                <v-col cols="1.5" class="pl-2">
                  <div style="position: relative;">
                    <v-select
                      v-model="model.retention_status"
                      :items="['Always', 'Yes', 'No']"
                      variant="outlined"
                      persistent-placeholder
                      label="Retention"
                      hide-details
                      density="compact"
                      style="margin-bottom: 0 !important; height: 34px !important; font-weight: bold !important; font-size: 16px !important;"
                      :disabled="!canEditModel(model)"
                      @update:modelValue="debounceSave(model.id)"
                    ></v-select>
                    <template v-if="model.retention_status === 'No' && (model.retention_flag === 'red' || model.retention_flag === 'yellow')">
                      <v-icon
                        :color="model.retention_flag === 'red' ? 'red' : 'yellow'"
                        class="ml-1 align-self-center"
                        style="margin-top: 6px; position: absolute; right: 36px; top: 4px; z-index: 1;"
                        size="20"
                      >
                        mdi-alert-circle-outline
                      </v-icon>
                    </template>
                  </div>
                </v-col>
                <v-col cols="1.5" class="pl-2">
                  <v-select
                    v-if="model.location === 'Satellite'"
                    v-model="model.satellite_rate_type"
                    :items="satelliteRateTypeOptions"
                    variant="outlined"
                    persistent-placeholder
                    label="Rate Type"
                    hide-details
                    density="compact"
                    style="margin-bottom: 0 !important; height: 34px !important; font-weight: bold !important; font-size: 16px !important;"
                    :disabled="!canEditModel(model)"
                    @update:modelValue="saveSatelliteRateType(model)"
                  ></v-select>
                  <v-select
                    v-else
                    v-model="model.subsidy"
                    :items="getSubsidyOptionsForModel(model)"
                    variant="outlined"
                    persistent-placeholder
                    label="Subsidy"
                    hide-details
                    density="compact"
                    style="margin-bottom: 0 !important; height: 34px !important; font-weight: bold !important; font-size: 16px !important;"
                    :disabled="!canEditModel(model)"
                    @update:modelValue="handleSubsidySelection(model, $event)"
                  ></v-select>
                </v-col>
                <v-col cols="1" class="pl-2">
                  <v-text-field
                    v-model="model.hours"
                    variant="outlined"
                    persistent-placeholder
                    label="Hours"
                    autocomplete="off"
                    hide-details
                    density="compact"
                    style="margin-bottom: 0 !important; height: 34px !important; font-weight: bold !important; font-size: 16px !important;"
                    :disabled="!canEditModel(model)"
                    @update:modelValue="handleSatelliteHoursInput(model, $event)"
                  ></v-text-field>
                </v-col>
                <v-col cols="1" class="pl-2">
                  <v-text-field
                    v-model="model.percentage"
                    variant="outlined"
                    persistent-placeholder
                    label="%"
                    autocomplete="off"
                    hide-details
                    density="compact"
                    style="margin-bottom: 0 !important; height: 34px !important; font-weight: bold !important; font-size: 16px !important;"
                    :disabled="!canEditModel(model)"
                    @update:modelValue="handleSatellitePercentageInput(model, $event)"
                  ></v-text-field>
                </v-col>
                <v-col
                  cols="1"
                  class="text-center d-flex justify-center"
                  style="padding-left: 0 !important; flex: 0 0 5%; max-width: 5%; margin-left: auto;"
                >
                  <v-btn 
                    icon 
                    class="btn-primary" 
                    density="comfortable" 
                    @click="addAdjustment(modelIndex)"
                    :disabled="!canEditModel(model)"
                  >
                    <v-icon>mdi-plus</v-icon>
                  </v-btn>
                </v-col>
              </v-row>
            </v-container>
            <v-container
              v-if="!hasVisibleAdjustments(model)"
              fluid
              class="pa-2"
              style="padding-bottom: 0px !important;"
            >
            </v-container>

            <div v-if="hasVisibleAdjustments(model)">
              <v-divider style="border-color: #e0e0e0; margin: 0;"></v-divider>
              <v-container
                fluid
                class="pa-2"
                style="padding: 5px !important;"
              >
                <v-row no-gutters dense style="margin: -5px 0 -7px 0 !important; padding: 0 !important;">
                  <v-col cols="12">
                    <v-row no-gutters align="center">
                      <v-col style="flex: 0 0 12%; max-width: 12%; padding-left: 6px;">
                        <span style="font-size: 12px; font-weight: 600; color: #707070;">Type</span>
                      </v-col>
                      <v-col style="flex: 0 0 10%; max-width: 10%; padding-left: 6px;">
                        <span style="font-size: 12px; font-weight: 600; color: #707070;">Amount</span>
                      </v-col>
                      <v-col style="flex: 0 0 9%; max-width: 9%; padding-left: 6px;">
                        <span style="font-size: 12px; font-weight: 600; color: #707070;">Xe</span>
                      </v-col>
                      <v-col style="flex: 0 0 33%; max-width: 33%; padding-left: 6px;">
                        <span style="font-size: 12px; font-weight: 600; color: #707070;">Description</span>
                      </v-col>
                      <v-col style="flex: 0 0 6%; max-width: 6%; padding-left: 4px;">
                        <span style="font-size: 12px; font-weight: 600; color: #707070;">Quantity</span>
                      </v-col>
                      <v-col style="flex: 0 0 7%; max-width: 7%; padding-left: 6px;">
                        <span style="font-size: 12px; font-weight: 600; color: #707070;">Quotas</span>
                      </v-col>
                      <v-col style="flex: 0 0 8%; max-width: 8%; padding-left: 6px;">
                        <span style="font-size: 12px; font-weight: 600; color: #707070;">Site</span>
                      </v-col>
                      <v-col style="flex: 0 0 10%; max-width: 10%; padding-left: 6px;">
                        <span style="font-size: 12px; font-weight: 600; color: #707070;">Date</span>
                      </v-col>
                      <v-col style="flex: 0 0 5%; max-width: 5%; padding-left: 0px;" class="text-center">
                        <span style="font-size: 12px; font-weight: 600; color: #707070;">Actions</span>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>

                <v-data-table
                  :items="model.adjustments"
                  class="elevation-0 adjustments-rows-table"
                  hide-default-footer
                  hide-default-header
                  density="compact"
                  :items-per-page="-1"
                  style="background-color: white; padding: 0 0 3px 0 !important; margin: 0 !important;"
                >
                  <template v-slot:item="{ item, index: adjIndex }">
                    <tr
                      v-show="!item.nextPeriod"
                      :title="item.payout_status === 'awaiting_payment' ? 'Awaiting Card Payment · included in Modato totals, excluded from WIZ export' : ''"
                      :style="{
                      backgroundColor: item.payout_status === 'awaiting_payment' ? '#fff8e1' : (item.insufficientFunds ? '#fff2f2' : 'transparent'),
                      borderBottom: 'none'
                    }"
                    >
                      <td :style="{ width: '12%', opacity: (item.nextPeriod || item.insufficientFunds) ? 0.5 : 1, padding: '0 2px', borderBottom: 'none !important' }">
                        <v-select
                          v-model="item.type"
                          :items="['Purchase', 'Discount', 'Adjustment', 'Site Bonus', 'Studio Bonus']"
                          :item-title="t => t"
                          :item-value="t => t"
                          :style="{
                            color: 'black',
                            borderLeft: ['Purchase', 'Discount'].includes(item.type) ? '2px solid #ff1744' : '2px solid #8CDA4D'
                          }"
                          density="compact"
                          outlined
                          hide-details
                          style="height: 30px !important; font-size: 14px; width: 100%;"
                          :disabled="!canEdit || model.isLocked || item.nextPeriod || item.card_expense_id || item.cash_box_entry_id"
                          @update:modelValue="handleAcceptedTypeChange(model, item, adjIndex)"
                        ></v-select>
                      </td>
                      <td :style="{ width: '10%', opacity: (item.nextPeriod || item.insufficientFunds) ? 0.5 : 1, padding: '0 2px !important', borderBottom: 'none !important' }">
                        <v-text-field
                          v-model="item.amount"
                          density="compact"
                          outlined
                          hide-details
                          style="height: 30px !important; font-size: 14px;"
                          :rules="[v => /^[0-9.]*$/.test(v) || 'Only numbers and one decimal allowed']"
                          :disabled="!canEdit || model.isLocked || item.nextPeriod || item.card_expense_id || item.cash_box_entry_id"
                          @blur="formatAmount(item)"
                          @input="markAdjustmentAsEdited(model.id, adjIndex)"
                        ></v-text-field>
                      </td>
                      <td :style="{ width: '9%', opacity: (item.nextPeriod || item.insufficientFunds) ? 0.5 : 1, padding: '0 2px', borderBottom: 'none !important' }">
                        <v-select
                          v-model="item.currency"
                          :items="currencyOptions"
                          :item-title="c => c"
                          :item-value="c => c"
                          :style="{
                            color: 'black',
                            borderLeft: item.currency === 'COP' ? '2px solid #fbc02d' :
                                        item.currency === 'USD' ? '2px solid #74B341' :
                                        item.currency === 'EUR' ? '2px solid #1e88e5' : '2px solid #ccc'
                          }"
                          density="compact"
                          hide-details
                          style="height: 30px !important; font-size: 14px; width: 100%;"
                          :disabled="!canEdit || model.isLocked || item.nextPeriod || item.card_expense_id || item.cash_box_entry_id"
                          @update:modelValue="markAdjustmentAsEdited(model.id, adjIndex)"
                        ></v-select>
                      </td>
                      <td :style="{ width: '33%', opacity: (item.nextPeriod || item.insufficientFunds) ? 0.5 : 1, padding: '0 2px !important', borderBottom: 'none !important' }">
                        <v-menu
                          v-if="item.type === 'Purchase'"
                          v-model="item.inventory_menu_open"
                          location="bottom"
                          :close-on-content-click="true"
                          max-height="280"
                        >
                          <template #activator="{ props }">
                            <v-text-field
                              v-bind="props"
                              v-model="item.description"
                              density="compact"
                              outlined
                              hide-details
                              autocomplete="off"
                              style="height: 30px !important; font-size: 14px;"
                              :disabled="!canEdit || model.isLocked || item.nextPeriod || item.card_expense_id || item.cash_box_entry_id"
                              @update:modelValue="handleAcceptedDescription(model, item, adjIndex, $event)"
                            >
                              <template #append-inner>
                                <v-icon
                                  v-if="item.inventory_item_id"
                                  color="success"
                                  size="17"
                                  title="Linked to Inventory"
                                >mdi-package-variant-closed</v-icon>
                              </template>
                            </v-text-field>
                          </template>
                          <v-list v-if="filteredAcceptedInventoryOptions(model, item).length" density="compact">
                            <v-list-item
                              v-for="inventoryItem in filteredAcceptedInventoryOptions(model, item)"
                              :key="inventoryItem.id"
                              :title="inventoryItem.name"
                              :subtitle="`${inventoryItem.quantity_on_hand} in stock · ${formatAmountLabel(inventoryItem.default_selling_price)}`"
                              @click="selectAcceptedInventoryItem(model, item, adjIndex, inventoryItem)"
                            />
                          </v-list>
                          <v-list v-else density="compact">
                            <v-list-item title="No matching inventory item" />
                          </v-list>
                        </v-menu>
                        <v-menu
                          v-else-if="item.type === 'Discount'"
                          v-model="item.recovery_menu_open"
                          location="bottom"
                          :close-on-content-click="true"
                          max-height="220"
                        >
                          <template #activator="{ props }">
                            <v-text-field
                              v-bind="props"
                              v-model="item.description"
                              density="compact"
                              outlined
                              hide-details
                              autocomplete="off"
                              style="height: 30px !important; font-size: 14px;"
                              :disabled="!canEdit || model.isLocked || item.nextPeriod || item.card_expense_id || item.cash_box_entry_id"
                              @focus="item.recovery_menu_open = true"
                              @update:modelValue="handleDiscountDescriptionInput(model, item, adjIndex, $event)"
                            >
                              <template #append-inner>
                                <v-icon
                                  v-if="item.recovery_source === 'cash_box'"
                                  color="#27845b"
                                  size="18"
                                  title="Linked to Cash Box"
                                >mdi-cash-multiple</v-icon>
                                <v-icon
                                  v-else-if="item.recovery_type || item.card_expense_id"
                                  color="#2f7db9"
                                  size="18"
                                  :title="item.card_expense_id ? 'Linked to Card Expenses' : 'Will link to Card Expenses when saved'"
                                >mdi-credit-card-outline</v-icon>
                                <v-icon
                                  v-else-if="looksLikeRecoveryDescription(item.description)"
                                  color="warning"
                                  size="18"
                                  title="Select Adelanto de Pago or Préstamo from the list"
                                >mdi-alert-circle-outline</v-icon>
                              </template>
                            </v-text-field>
                          </template>
                          <v-list v-if="filteredRecoveryDescriptions(item).length" density="compact">
                            <v-list-item
                              v-for="option in filteredRecoveryDescriptions(item)"
                              :key="option.value"
                              :title="option.title"
                              @click="selectRecoveryDescription(model, item, adjIndex, option)"
                            >
                              <template #prepend>
                                <v-icon color="#2f7db9" size="18">mdi-credit-card-outline</v-icon>
                              </template>
                            </v-list-item>
                          </v-list>
                        </v-menu>
                        <v-text-field
                          v-else
                          v-model="item.description"
                          density="compact"
                          outlined
                          hide-details
                          style="height: 30px !important; font-size: 14px;"
                          :disabled="!canEdit || model.isLocked || item.nextPeriod || item.card_expense_id || item.cash_box_entry_id"
                          @input="markAdjustmentAsEdited(model.id, adjIndex)"
                        />
                      </td>
                      <td :style="{ width: '6%', opacity: (item.nextPeriod || item.insufficientFunds) ? 0.5 : 1, padding: '0 2px !important', borderBottom: 'none !important', textAlign: 'center' }">
                        <v-combobox
                          v-if="item.type === 'Purchase'"
                          v-model="item.inventory_quantity"
                          :items="numberOptions"
                          class="adjustment-quantity-field"
                          density="compact"
                          outlined
                          hide-details
                          autocomplete="off"
                          inputmode="numeric"
                          style="height: 30px !important; font-size: 14px;"
                          :disabled="!canEdit || model.isLocked || item.nextPeriod || item.card_expense_id || item.cash_box_entry_id"
                          @update:modelValue="handleAcceptedQuantityChange(model, item, adjIndex, $event)"
                        ></v-combobox>
                        <v-text-field
                          v-else
                          model-value="—"
                          class="adjustment-quantity-field"
                          density="compact"
                          outlined
                          hide-details
                          readonly
                          style="height: 30px !important; font-size: 14px;"
                        />
                      </td>
                      <td :style="{ width: '7%', opacity: (item.nextPeriod || item.insufficientFunds) ? 0.5 : 1, padding: '0 2px !important', borderBottom: 'none !important' }">
                        <v-text-field
                          :model-value="`${item.number}/${item.quotas}`"
                          readonly
                          density="compact"
                          outlined
                          hide-details
                          style="height: 30px !important; font-size: 14px;"
                          :disabled="!canEdit || model.isLocked || item.nextPeriod || item.card_expense_id || item.cash_box_entry_id"
                          @click="openQuotasEditor(model.id, adjIndex, item)"
                        ></v-text-field>
                      </td>
                      <td :style="{ width: '8%', opacity: (item.nextPeriod || item.insufficientFunds) ? 0.5 : 1, padding: '0 2px !important', borderBottom: 'none !important' }">
                        <v-select
                          v-model="item.site"
                          :items="getSiteOptionsForModel(model)"
                          item-title="menuLabel"
                          item-value="value"
                          density="compact"
                          outlined
                          hide-details
                          style="height: 30px !important; font-size: 14px;"
                          :disabled="!canEdit || model.isLocked || item.nextPeriod || item.card_expense_id || item.cash_box_entry_id"
                          @update:modelValue="markAdjustmentAsEdited(model.id, adjIndex)"
                        >
                          <template #selection>
                            {{ getSiteCode(item.site) }}
                          </template>
                        </v-select>
                      </td>
                      <td :style="{ width: '10%', opacity: (item.nextPeriod || item.insufficientFunds) ? 0.5 : 1, padding: '0 2px !important', borderBottom: 'none !important' }">
                        <v-date-input
                          v-model="item.date"
                          @update:modelValue="updateDateValue(modelIndex, adjIndex, $event); markAdjustmentAsEdited(model.id, adjIndex)"
                          prepend-icon=""
                          hide-details
                          density="compact"
                          :disabled="!canEdit || model.isLocked || item.nextPeriod || item.card_expense_id || item.cash_box_entry_id"
                          :menu-props="{ closeOnContentClick: true, offsetY: true, closeOnSelect: true }"
                          hide-actions
                          placeholder="YYYY-MM-DD"
                          style="height: 30px !important; font-size: 14px;"
                        ></v-date-input>
                      </td>
                      <td class="text-center btn-primary" style="width: 5%; padding: 10px 0 0 0 !important; border-bottom: none !important; opacity: 1 !important; pointer-events: auto;">
                        <v-menu v-if="(item.card_expense_id || item.cash_box_entry_id) && canEdit" min-width="220">
                          <template #activator="{ props }">
                            <v-btn
                              v-bind="props"
                              icon
                              class="btn-primary"
                              density="comfortable"
                              title="Linked recovery actions"
                            >
                              <v-icon size="small" color="black">mdi-dots-horizontal</v-icon>
                            </v-btn>
                          </template>
                          <v-list density="compact">
                            <v-list-item
                              v-if="item.cash_box_entry_id"
                              title="Open in Cash Box"
                              prepend-icon="mdi-cash-multiple"
                              @click="manageLinkedCashBox(model, item)"
                            />
                            <v-list-item
                              v-if="item.card_expense_id"
                              title="Open in Card Expenses"
                              prepend-icon="mdi-credit-card-outline"
                              @click="manageLinkedCardExpense(model, item)"
                            />
                            <v-list-item
                              v-if="item.card_expense_id"
                              title="Delete Linked Recovery"
                              prepend-icon="mdi-delete-outline"
                              base-color="error"
                              @click="deleteLinkedRecovery(model, item)"
                            />
                          </v-list>
                        </v-menu>
                        <v-btn
                          v-else
                          icon 
                          class="btn-primary" 
                          density="comfortable" 
                          :disabled="!canEdit || model.isLocked"
                          title="Adjustment actions"
                          @click="item.isNew || item.isEdited ? saveAdjustment(model.id, adjIndex) : openActionDialog(modelIndex, adjIndex)"
                        >
                          <div
                            :style="item.observation ? {
                              border: '3px solid #2196F3',
                              borderRadius: '50%',
                              padding: '5px',
                              display: 'inline-flex',
                              alignItems: 'center',
                              justifyContent: 'center'
                            } : {}"
                          >
                            <v-icon size="small" :color="item.isNew || item.isEdited ? 'blue' : 'black'">
                              {{ item.isNew || item.isEdited ? 'mdi-content-save' : 'mdi-dots-horizontal' }}
                            </v-icon>
                          </div>
                        </v-btn>
                      </td>
                    </tr>
                  </template>
                </v-data-table>
              </v-container>
            </div>
          </v-card>
        </v-col>
      </v-row>

      <v-card class="studio-account-card elevation-3">
        <div class="studio-account-header">
          <div>
            <div class="studio-account-title">{{ studioAccountName }}</div>
            <div class="studio-account-subtitle">Internal studio use · no sale or model earnings</div>
          </div>
          <div class="studio-account-actions">
            <v-icon color="primary">mdi-office-building-cog-outline</v-icon>
            <v-btn
              icon
              class="btn-primary"
              density="comfortable"
              :disabled="!canEdit || isPeriodLocked"
              aria-label="Add studio product"
              title="Add studio product"
              @click="openDirectStudioUseDialog"
            >
              <v-icon>mdi-plus</v-icon>
            </v-btn>
          </div>
        </div>
        <div v-if="studioUses.length" class="studio-account-table-wrap">
          <table class="studio-account-table">
            <thead>
              <tr>
                <th>Type</th>
                <th>Description</th>
                <th>Quantity</th>
                <th>Site</th>
                <th>Date</th>
                <th>Observation</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="entry in studioUses" :key="entry.id">
                <td>Studio Use</td>
                <td>
                  <span>{{ entry.itemName }}</span>
                  <v-icon class="ml-1" color="success" size="16" title="Linked to Inventory">
                    mdi-package-variant-closed
                  </v-icon>
                </td>
                <td>{{ entry.quantity }}</td>
                <td>{{ studioAccountCode }}</td>
                <td>{{ formatPeriodDateLabel(entry.useDate) }}</td>
                <td>{{ entry.notes || '—' }}</td>
                <td><v-chip color="success" size="small" variant="tonal">Recorded</v-chip></td>
              </tr>
            </tbody>
          </table>
        </div>
        <div v-else class="studio-account-empty">
          No internal studio-use items recorded in this period.
        </div>
      </v-card>
    </v-container>

    <section ref="directSalesSection" class="direct-sales-section">
      <div class="direct-sales-header">
        <span>Direct Sales</span>
        <v-btn
          icon
          class="btn-primary"
          density="comfortable"
          :disabled="!canEdit"
          aria-label="Add direct sale"
          @click="addDirectSale"
        >
          <v-icon>mdi-plus</v-icon>
        </v-btn>
      </div>

      <div v-if="directSales.length" class="direct-sales-body">
        <div class="direct-sales-labels">
          <span>Full Name</span>
          <span>Item</span>
          <span>Quantity</span>
          <span>Sale Price</span>
          <span>Method</span>
          <span>Date</span>
          <span></span>
        </div>
        <div v-for="sale in directSales" :key="sale.id" class="direct-sale-row">
          <v-text-field
            v-model="sale.buyerName"
            density="compact"
            hide-details
            autocomplete="off"
            placeholder="Full name"
            :readonly="sale.recorded"
            variant="outlined"
          />
          <v-menu
            v-if="!sale.recorded && !sale.sourcePendingId"
            v-model="sale.itemMenuOpen"
            location="bottom"
            :close-on-content-click="true"
            max-height="280"
          >
            <template #activator="{ props }">
              <v-text-field
                v-bind="props"
                v-model="sale.itemName"
                density="compact"
                hide-details
                autocomplete="off"
                placeholder="Search inventory"
                variant="outlined"
                @update:modelValue="handleDirectSaleItemInput(sale, $event)"
              />
            </template>
            <v-list v-if="filteredDirectSaleItems(sale).length" density="compact">
              <v-list-item
                v-for="inventoryItem in filteredDirectSaleItems(sale)"
                :key="inventoryItem.id"
                :title="inventoryItem.name"
                :subtitle="`${inventoryItem.quantity_on_hand} in stock · ${formatAmountLabel(inventoryItem.default_selling_price)}`"
                @click="selectDirectSaleItem(sale, inventoryItem)"
              />
            </v-list>
            <v-list v-else density="compact">
              <v-list-item title="No matching inventory item" />
            </v-list>
          </v-menu>
          <v-text-field
            v-else
            v-model="sale.itemName"
            density="compact"
            hide-details
            readonly
            variant="outlined"
          />
          <v-combobox
            v-model="sale.quantity"
            :items="numberOptions"
            density="compact"
            hide-details
            inputmode="numeric"
            :readonly="sale.recorded"
            variant="outlined"
            @update:modelValue="handleDirectSaleQuantity(sale, $event)"
          />
          <v-text-field
            v-model="sale.saleTotal"
            density="compact"
            hide-details
            inputmode="decimal"
            :readonly="sale.recorded"
            variant="outlined"
            @blur="formatDirectSalePrice(sale)"
          />
          <v-select
            v-model="sale.paymentMethod"
            :items="directSalePaymentMethods"
            density="compact"
            :readonly="sale.recorded"
            hide-details
            variant="outlined"
          />
          <v-date-input
            v-model="sale.saleDate"
            density="compact"
            :readonly="sale.recorded"
            hide-actions
            hide-details
            placeholder="YYYY-MM-DD"
            prepend-icon=""
            variant="outlined"
          />
          <div class="direct-sale-actions">
            <v-menu v-if="sale.recorded" location="bottom end" :disabled="!canEdit">
              <template #activator="{ props }">
                <v-btn
                  v-bind="props"
                  icon="mdi-dots-horizontal"
                  size="small"
                  variant="text"
                  aria-label="Direct sale options"
                />
              </template>
              <v-list density="compact" min-width="170">
                <v-list-item
                  prepend-icon="mdi-pencil-outline"
                  title="Edit"
                  :disabled="!canEdit"
                  @click="editDirectSale(sale)"
                />
                <v-list-item
                  prepend-icon="mdi-note-text-outline"
                  title="Observation"
                  :disabled="!canEdit"
                  @click="openDirectSaleObservation(sale)"
                />
                <v-list-item
                  prepend-icon="mdi-delete-outline"
                  title="Delete"
                  :disabled="!canEdit"
                  @click="deleteDirectSale(sale)"
                />
              </v-list>
            </v-menu>
            <v-btn
              v-else
              icon="mdi-content-save"
              color="primary"
              size="small"
              :loading="sale.saving"
              :disabled="!canSaveDirectSale(sale)"
              aria-label="Record direct sale"
              @click="saveDirectSale(sale)"
            />
          </div>
        </div>
      </div>
    </section>

    <v-dialog v-model="directSaleObservation.open" max-width="520">
      <v-card>
        <v-card-title>Direct Sale Observation</v-card-title>
        <v-card-text>
          <div class="mb-3 text-body-2">
            {{ directSaleObservation.sale?.buyerName }} · {{ directSaleObservation.sale?.itemName }}
          </div>
          <v-textarea
            v-model="directSaleObservation.notes"
            label="Observation"
            rows="3"
            maxlength="500"
            counter
            autofocus
            variant="outlined"
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn variant="text" @click="directSaleObservation.open = false">Cancel</v-btn>
          <v-btn
            color="primary"
            :loading="directSaleObservation.saving"
            @click="saveDirectSaleObservation"
          >Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog" max-width="500px">
      <v-card>
        <v-card-title class="headline">Add Model</v-card-title>
        <v-card-text>
          <v-text-field
            v-model="searchQuery"
            label="Search by Name or Stage Name"
            prepend-inner-icon="mdi-magnify"
            clearable
            hide-details
            density="compact"
            :disabled="!canEdit"
            @input="fetchAvailableModels"
          ></v-text-field>
          <v-list>
            <v-list-item v-for="model in filteredAvailableModels" :key="model.id" @click="canEdit && selectModel(model.id)">
              <v-list-item-title>{{ model.fullName }} ({{ model.stageName }})</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-card-text>
        <v-card-actions>
          <v-btn color="primary" @click="dialog = false">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="actionDialog" :max-width="600" :max-height="380" content-class="small-dialog">
      <v-card class="pa-3">
        <v-card-text class="pa-0">
          <v-row justify="space-between" align="start">
            <v-col cols="6">
              <div style="font-weight: bold; font-size: 14px;">
                {{ filteredModels[selectedModelIndex]?.fullName }}
              </div>
              <div style="color: #2C74B3; font-weight: 500; font-size: 13px;">
                {{ filteredModels[selectedModelIndex]?.stageName }}
              </div>
            </v-col>
            <v-col cols="6" class="text-right">
              <div style="font-size: 13px;">
                <strong>{{ filteredModels[selectedModelIndex]?.adjustments?.[selectedAdjIndex]?.type }}</strong>
                {{ filteredModels[selectedModelIndex]?.adjustments?.[selectedAdjIndex]?.amount }}
                {{ filteredModels[selectedModelIndex]?.adjustments?.[selectedAdjIndex]?.currency }}
              </div>
              <div style="font-size: 13px; color: #707070;">
                {{ filteredModels[selectedModelIndex]?.adjustments?.[selectedAdjIndex]?.number }}/{{ filteredModels[selectedModelIndex]?.adjustments?.[selectedAdjIndex]?.quotas }}
              </div>
            </v-col>
          </v-row>

          <v-row dense align="center" justify="space-around">
            <v-col class="text-center">
              <div class="mb-1" style="font-weight: 500;">Next Period</div>
              <v-btn 
                icon 
                @click="sendToNextPeriod(selectedModelIndex, selectedAdjIndex)"
                :disabled="!canEdit || (filteredModels[selectedModelIndex]?.isLocked)"
              >
                <v-icon>mdi-arrow-right</v-icon>
              </v-btn>
            </v-col>
            <v-col class="text-center">
              <div class="mb-1" style="font-weight: 500;">Insufficient Funds</div>
              <v-btn 
                icon 
                @click="toggleInsufficientFunds(selectedModelIndex, selectedAdjIndex)"
                :disabled="!canEdit || (filteredModels[selectedModelIndex]?.isLocked)"
              >
                <v-icon>mdi-currency-usd-off</v-icon>
              </v-btn>
            </v-col>
            <v-col class="text-center">
              <div class="mb-1" style="font-weight: 500;">Delete</div>
              <v-btn 
                icon 
                @click="removeAdjustment(selectedModelIndex, selectedAdjIndex)"
                :disabled="!canEdit || (filteredModels[selectedModelIndex]?.isLocked)"
              >
                <v-icon>mdi-delete</v-icon>
              </v-btn>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <div style="font-style: regular; font-size: 13px;">
                {{ filteredModels[selectedModelIndex]?.adjustments?.[selectedAdjIndex]?.description }}
              </div>
            </v-col>
          </v-row>
          <v-textarea
            v-model="editingAdjustment.observation"
            label="Observation"
            outlined
            rows="2"
            auto-grow
            :disabled="!canEdit || (filteredModels[selectedModelIndex]?.isLocked)"
          />
        </v-card-text>
        <v-card-actions class="pa-0" style="padding-top: 0; margin-top: -25px; margin-bottom: -15px; display: flex; justify-content: flex-end; gap: 12px;">
          <v-btn variant="plain" dense @click="closeDialog">Ok</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="quotasEditor.open" max-width="320">
      <v-card>
        <v-card-title style="font-size: 15px; font-weight: 600; padding-bottom: 6px;">Edit Quotas</v-card-title>
        <v-card-text style="padding-top: 8px; padding-bottom: 6px;">
          <v-row dense>
            <v-col cols="6">
              <v-select
                v-model="quotasEditor.current"
                :items="quotaCurrentOptions"
                label="Current #"
                density="compact"
                hide-details
                outlined
              />
            </v-col>
            <v-col cols="6">
              <v-select
                v-model="quotasEditor.total"
                :items="numberOptions"
                label="Total Quotas"
                density="compact"
                hide-details
                outlined
              />
            </v-col>
          </v-row>
          <div style="font-size: 12px; color: #707070; margin-top: 8px;">
            Rule: Current cannot be greater than Total.
          </div>
        </v-card-text>
        <v-card-actions style="justify-content: flex-end;">
          <v-btn variant="text" @click="closeQuotasEditor">Cancel</v-btn>
          <v-btn color="primary" variant="text" @click="saveQuotasEditor">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="subsidyConfirm.open" max-width="520" persistent>
      <v-card>
        <v-card-title style="font-size: 18px; font-weight: 600;">
          Link subsidy to Chaturbate?
        </v-card-title>
        <v-card-text style="padding-top: 8px;">
          Usually, subsidy fits better with the main payment, because both are based on 2 weeks.
        </v-card-text>
        <v-card-actions style="justify-content: flex-end; gap: 8px;">
          <v-btn color="primary" variant="text" @click="confirmSubsidyUseCb">Use CB</v-btn>
          <v-btn color="primary" variant="text" @click="confirmSubsidyUseMain">Use Main</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="lateWarning.open" max-width="560" persistent>
      <v-card>
        <v-card-title>Review adjustment period</v-card-title>
        <v-card-text>{{ lateWarning.message }} If these changes affect Jorge’s payment, send him an updated Excel.</v-card-text>
        <v-card-actions>
          <v-btn variant="text" @click="resolveLateWarning('cancel')">Cancel</v-btn>
          <v-spacer />
          <v-btn v-if="lateWarning.allowNext" color="primary" variant="tonal" @click="resolveLateWarning('next')">Send to Next Period</v-btn>
          <v-btn variant="text" @click="resolveLateWarning('current')">Add Here Anyway</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="studioUseDialog.open" max-width="520">
      <v-card>
        <v-card-title>{{ studioUseDialog.direct ? `Add Product to ${studioAccountName}` : 'Record Studio Use' }}</v-card-title>
        <v-card-text>
          <div v-if="!studioUseDialog.direct" class="mb-3 text-body-2 font-weight-medium">
            {{ studioUseDialog.items[0]?.model_name }}
          </div>
          <div v-if="!studioUseDialog.direct" class="mb-3 studio-use-dialog-items">
            <div v-for="item in studioUseDialog.items" :key="item.id">
              {{ item.inventory_quantity || 1 }} × {{ item.description }}
            </div>
          </div>
          <v-autocomplete
            v-if="studioUseDialog.direct"
            v-model="studioUseDialog.itemId"
            :items="directSaleInventoryOptions()"
            item-title="name"
            item-value="id"
            label="Inventory Product"
            class="mb-3"
            density="compact"
            variant="outlined"
            hide-details
            autocomplete="off"
          >
            <template #item="{ props, item }">
              <v-list-item
                v-bind="props"
                :subtitle="`${item.raw.quantity_on_hand} in stock`"
              />
            </template>
          </v-autocomplete>
          <v-row v-if="studioUseDialog.direct" dense class="mb-2">
            <v-col cols="4">
              <v-combobox
                v-model="studioUseDialog.quantity"
                :items="numberOptions"
                label="Quantity"
                density="compact"
                variant="outlined"
                hide-details
                inputmode="numeric"
              />
            </v-col>
            <v-col cols="8">
              <v-date-input
                v-model="studioUseDialog.useDate"
                label="Date"
                density="compact"
                variant="outlined"
                prepend-icon=""
                hide-actions
                hide-details
              />
            </v-col>
          </v-row>
          <v-alert class="mb-4" color="info" variant="tonal">
            Inventory is reduced at internal cost. No sale or income is created.
          </v-alert>
          <v-textarea
            v-model="studioUseDialog.notes"
            label="Observation"
            placeholder="Replacement, gift, studio equipment, etc."
            rows="3"
            maxlength="500"
            counter
            autofocus
            variant="outlined"
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn :disabled="studioUseDialog.saving" variant="text" @click="studioUseDialog.open = false">Cancel</v-btn>
          <v-btn
            color="primary"
            :loading="studioUseDialog.saving"
            :disabled="studioUseDialog.direct && !canSaveDirectStudioUse()"
            @click="saveStudioUse"
          >Save Studio Use</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="subsidyDownloadConfirm.open" max-width="520" persistent>
      <v-card>
        <v-card-title style="font-size: 18px; font-weight: 600;">
          Review subsidies before downloading?
        </v-card-title>
        <v-card-text style="padding-top: 8px;">
          Every model currently has subsidy set to None. This usually means subsidies have not been reviewed yet.
        </v-card-text>
        <v-card-actions style="justify-content: flex-end; gap: 8px;">
          <v-btn variant="text" @click="cancelSubsidyWarning">Cancel</v-btn>
          <v-btn color="primary" variant="text" @click="confirmDownloadWithoutSubsidies">
            Download Anyway
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Hidden Excel Export Component -->
    <AdjustmentsExcel
      ref="adjustmentsExcel"
      :period="periods.find(p => p.id === selectedPeriod)"
      :models="filteredModels"
    />
  </div>
</template>












<script>
import secureAxios from '@/utils/secureAxios';
import { toast } from 'vue3-toastify';
import debounce from 'lodash/debounce';
import AdjustmentsExcel from '@/components/AdjustmentsExcel.vue';

const createDirectSaleRow = () => ({
  id: globalThis.crypto?.randomUUID?.() || `direct-sale-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`,
  buyerName: '',
  itemId: null,
  itemName: '',
  itemMenuOpen: false,
  unitPrice: 0,
  quantity: 1,
  saleTotal: '0',
  paymentMethod: 'Cash',
  saleDate: new Date(),
  saving: false,
  recorded: false,
  isEditing: false,
  notes: '',
  sourcePendingId: null,
});

export default {
  components: {
    AdjustmentsExcel,
  },
  data() {
    const user = JSON.parse(localStorage.getItem('user'));
    return {
      user,
      activeTab: user?.role === 'satellite_monitor' ? 'satellite' : 'studio',
      selectedPeriod: null,
      periods: [],
      models: [],
      inventoryItems: [],
      directSales: [],
      directSalesLoading: false,
      directSalePaymentMethods: ['Cash', 'Bank Transfer'],
      directSaleObservation: {
        open: false,
        sale: null,
        notes: '',
        saving: false,
      },
      studioUseDialog: {
        open: false,
        direct: false,
        items: [],
        itemId: null,
        quantity: 1,
        useDate: new Date(),
        notes: '',
        saving: false,
      },
      studioUses: [],
      pendingAdjustments: [],
      exportStatus: {},
      exportDownloading: false,
      lateWarning: { open: false, message: '', allowNext: false },
      pendingLoading: false,
      pendingActionId: null,
      subsidyOptions: ['Full - Main', 'Half - Main', 'Full - CB', 'Half - CB', 'None'],
      satelliteRateTypeOptions: ['Scale', 'Fixed'],
      currencyOptions: ["USD", "COP", "EUR"],
      numberOptions: [1, 2, 3, 4, 5, 6],
      siteOptions: [
        { label: 'F4F', value: 'Flirt4Free' },
        { label: 'SM', value: 'Streamate' },
        { label: 'LJ', value: 'LiveJasmin' },
        { label: 'SC', value: 'Stripchat' },
        { label: 'CB', value: 'Chaturbate' }
      ],
      dialog: false,
      searchQuery: '',
      availableModels: [],
      isSaving: false,
      actionDialog: false,
      selectedModelIndex: null,
      selectedAdjIndex: null,
      editingAdjustment: {},
      isPeriodLocked: false,
      lockedByStudio: {},
      activeCard: null,
      modelFilter: null,
      selectedModels: [],
      filterOptions: ['Classes', 'Subsidy', 'Discounts', 'Purchases', 'Adjustments', 'Bonuses'],
      activeFilters: [],
      sortOptions: ['Full Name A → Z', 'Full Name Z → A', 'Stage Name A → Z', 'Stage Name Z → A'],
      sortOption: 'Full Name A → Z',
      searchKeyword: '',
      mainExcelNote: '',
      cbExcelNote: '',
      quotasEditor: {
        open: false,
        modelId: null,
        adjIndex: null,
        current: 1,
        total: 1
      },
      subsidyConfirm: {
        open: false,
        modelId: null,
        pendingValue: 'None'
      },
      subsidyDownloadConfirm: {
        open: false,
        group: 'main'
      },
      // user is assumed to be provided from a parent or global, or set elsewhere
    };
  },
  computed: {
    showSkippedCbWarning() {
      const selected = this.periods.find(p => p.id === this.selectedPeriod);
      const periodName = String(selected?.name || '').trim().toLowerCase();
      return periodName.includes('6-fox') || periodName.includes('19-seal');
    },
    isAdmin() {
      return JSON.parse(localStorage.getItem('user'))?.role === 'admin';
    },
    isSatelliteMonitor() {
      return this.user?.role === 'satellite_monitor';
    },
    canEdit() {
      return (this.isAdmin || this.isSatelliteMonitor) && !this.isPeriodLocked;
    },
    canEditModel() {
      return (model) => {
        return this.canEdit && !model?.isLocked;
      };
    },
    filteredModels() {
      let filtered = [...this.models];

      filtered = filtered.filter(model => {
        const hasAdjustments = model.adjustments?.length > 0 || model.classes > 0 || model.subsidy !== 'None';
        const isActive = (model.status || '').toString().toUpperCase() === 'ACTIVE';

        // Show models that are active OR have any recorded adjustments/classes/subsidy,
        // but always respect the activeTab/location filter.
        if (this.modelMatchesActiveTab(model) && (isActive || hasAdjustments)) return true;

        return false;
      });

      if (this.selectedModels.length > 0) {
        filtered = filtered.filter(model =>
          this.selectedModels.includes(model.fullName)
        );
      }

      if (this.activeFilters.length > 0) {
        filtered = filtered.map(model => {
          const hasClassFilter = this.activeFilters.includes('Classes') && model.classes > 0;
          const hasSubsidyFilter = this.activeFilters.includes('Subsidy') && model.subsidy !== 'None';
          const selectedTypesMap = {
            Discount: 'Discounts',
            Purchase: 'Purchases',
            Adjustment: 'Adjustments',
            'Site Bonus': 'Bonuses',
            'Studio Bonus': 'Bonuses',
            Bonus: 'Bonuses'
          };
          const selectedTypes = Object.keys(selectedTypesMap).filter(type =>
            this.activeFilters.includes(selectedTypesMap[type])
          );
          const matchingAdjustments = model.adjustments?.filter(adj =>
            selectedTypes.includes(adj.type)
          ) || [];
          const match =
            hasClassFilter ||
            hasSubsidyFilter ||
            (selectedTypes.length > 0 && matchingAdjustments.length > 0);
          return match
            ? { ...model, adjustments: selectedTypes.length > 0 ? matchingAdjustments : model.adjustments }
            : null;
        }).filter(Boolean);
      }

      const sortField = this.sortOption.includes('Full Name') ? 'fullName' : 'stageName';
      const direction = this.sortOption.includes('Z → A') ? -1 : 1;
      filtered.sort((a, b) => a[sortField].toLowerCase().localeCompare(b[sortField].toLowerCase()) * direction);

      return filtered;
    },
    studioAccountName() {
      const fromUse = this.studioUses[0]?.studioName;
      if (fromUse) return `Studio ${fromUse}`;
      const studioNames = { 1: 'CC', 2: 'CJ', 3: 'BOG', 4: 'PEI' };
      return `Studio ${studioNames[Number(this.user?.studio_id)] || ''}`.trim();
    },
    studioAccountCode() {
      return this.studioAccountName.replace(/^Studio\s+/i, '').trim();
    },
    modelFilterOptions() {
      const sortField = this.sortOption.includes('Full Name') ? 'fullName' : 'stageName';
      const direction = this.sortOption.includes('Z → A') ? -1 : 1;

      return [...this.models]
        .filter(model => this.modelMatchesActiveTab(model))
        .map(model => ({
          ...model,
          modelFilterLabel: `${model.fullName}${model.stageName ? ` (${model.stageName})` : ''}`
        }))
        .sort((a, b) => a[sortField].toLowerCase().localeCompare(b[sortField].toLowerCase()) * direction);
    },
    filteredAvailableModels() {
      const filtered = this.availableModels.filter(model =>
        model.fullName.toLowerCase().includes(this.searchQuery.toLowerCase()) ||
        model.stageName.toLowerCase().includes(this.searchQuery.toLowerCase())
      );
      return filtered;
    },
    pendingModelOptions() {
      return this.models.map((model) => ({
        id: model.id,
        fullName: model.fullName,
        stageName: model.stageName || '',
        label: `${model.fullName}${model.stageName ? ` (${model.stageName})` : ''}`,
      }));
    },
    pendingAdjustmentGroups() {
      const groups = new Map();
      this.pendingAdjustments.forEach((item) => {
        const reportedName = String(item.model_name || '').trim().toLocaleLowerCase();
        const key = item.model_id ? `model-${Number(item.model_id)}` : `reported-${reportedName || item.id}`;
        if (!groups.has(key)) groups.set(key, { key, items: [] });
        groups.get(key).items.push(item);
      });
      return [...groups.values()];
    },
    selectedPeriodRecord() {
      return this.periods.find(p => p.id === this.selectedPeriod) || null;
    },
    selectedPeriodIndex() {
      return this.periods.findIndex(period => period.id === this.selectedPeriod);
    },
    canGoToPreviousPeriod() {
      return this.selectedPeriodIndex > 0;
    },
    canGoToNextPeriod() {
      return this.selectedPeriodIndex !== -1 && this.selectedPeriodIndex < this.periods.length - 1;
    },
    pendingPreviousCbPeriod() {
      const today = new Date();
      const todayOnly = new Date(today.getFullYear(), today.getMonth(), today.getDate());

      return (this.periods || [])
        .map((period, index) => ({ period, index }))
        .filter(({ period, index }) =>
          period?.id !== this.selectedPeriod &&
          period?.cb_payment_date &&
          index === this.selectedPeriodIndex - 1
        )
        .map(({ period }) => {
          const mainPaymentDate = this.parseLocalDate(period.payment_date);
          const cbPaymentDate = this.parseLocalDate(period.cb_payment_date);
          const cbSendDeadline = this.getExcelSendDate(period.cb_payment_date);
          const mainRolloverDate = mainPaymentDate ? new Date(mainPaymentDate) : null;
          if (mainRolloverDate) mainRolloverDate.setDate(mainRolloverDate.getDate() + 1);
          return { period, cbPaymentDate, cbSendDeadline, mainRolloverDate };
        })
        .filter(({ cbPaymentDate, cbSendDeadline, mainRolloverDate }) =>
          cbPaymentDate &&
          cbSendDeadline &&
          mainRolloverDate &&
          todayOnly >= mainRolloverDate &&
          todayOnly <= cbSendDeadline
        )
        .sort((a, b) => a.cbPaymentDate - b.cbPaymentDate)[0]?.period || null;
    },
    quotaCurrentOptions() {
      const total = Number(this.quotasEditor.total) || 1;
      return Array.from({ length: total }, (_, i) => i + 1);
    }
  },
  methods: {
    formatExportTime(value) {
      return new Intl.DateTimeFormat('en-US', { timeZone: 'America/Bogota', month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit' }).format(new Date(value));
    },
    isFullGroupExport(exportModels) {
      const belongsToScope = model => this.isSatelliteMonitor
        ? model.location === 'Satellite'
        : ['Morning', 'Evening', 'Night'].includes(model.location);
      const includedIds = new Set(exportModels.map(model => model.id));
      const expected = this.models.filter(model => belongsToScope(model)
        && (String(model.status).toUpperCase() === 'ACTIVE' || this.hasVisibleAdjustments(model)));
      return this.activeFilters.length === 0
        && exportModels.every(belongsToScope)
        && expected.every(model => includedIds.has(model.id));
    },
    async fetchExportStatus(periodId = this.selectedPeriod) {
      const { data } = await secureAxios.get(`/api/adjustments/export-status/${periodId}`);
      if (Number(periodId) === Number(this.selectedPeriod)) this.exportStatus = data;
      return data;
    },
    showLateWarning(message, allowNext = false) {
      if (this.lateWarning.open) return Promise.resolve('cancel');
      this.lateWarning = { open: true, message, allowNext };
      return new Promise(resolve => { this._resolveLateWarning = resolve; });
    },
    resolveLateWarning(choice) {
      this.lateWarning.open = false;
      this._resolveLateWarning?.(choice);
      this._resolveLateWarning = null;
    },
    async approvePendingItems(items) {
      const periodId = this.selectedPeriod;
      const status = await this.fetchExportStatus(periodId);
      const groups = [...new Set(items.map(item => this.isCbSiteValue(item.site, this.models.find(model => model.id === item.model_id)) ? 'cb' : 'main'))];
      const lateGroups = groups.filter(group => status[group]?.downloaded_at || status[group]?.cutoff_passed);
      let targetPeriod = periodId;
      let confirmed = false;
      if (lateGroups.length) {
        const choice = await this.showLateWarning(`${lateGroups.map(g => g === 'cb' ? 'Chaturbate' : 'Main').join(' / ')} Excel has already been downloaded or its report cutoff has passed.`, true);
        if (choice === 'cancel') return [];
        if (choice === 'next') {
          const index = this.periods.findIndex(p => Number(p.id) === Number(periodId));
          const next = this.periods[index + 1];
          if (!next) throw new Error('No following period exists. Create the next period first.');
          targetPeriod = next.id;
          confirmed = true; // Choosing the destination is already an explicit action.
        } else confirmed = true;
      }
      let cbTarget = targetPeriod;
      if (items.some(item => this.isCbSiteValue(item.site, this.models.find(model => model.id === item.model_id)))) {
        const { data: skipped } = await secureAxios.get(`/api/adjustments/cb-destination/${targetPeriod}`);
        if (skipped) {
          if (!skipped.destination) throw new Error(skipped.message);
          if (!window.confirm(skipped.message)) return [];
          cbTarget = skipped.destination.id;
        }
      }
      return Promise.allSettled(items.map(item => secureAxios.post(`/api/adjustments/pending/${item.id}/approve`, {
        ...this.pendingApprovalPayload(item), period_id: this.isCbSiteValue(item.site, this.models.find(model => model.id === item.model_id)) ? cbTarget : targetPeriod, late_confirmation: confirmed || cbTarget !== targetPeriod,
      })));
    },
    debounceSave(modelId) {
      if (!this._adjustmentSaveDebouncers.has(modelId)) {
        this._adjustmentSaveDebouncers.set(modelId, debounce(() => {
          this._adjustmentSaveDebouncers.delete(modelId);
          return this.saveAdjustments(modelId);
        }, 1000));
      }
      this._adjustmentSaveDebouncers.get(modelId)();
    },
    debounceSaveExcelNotes() {
      this._excelNotesPending = true;
      this._excelNotesSaver();
    },
    async flushQueuedSaves() {
      const results = await Promise.all([
        ...[...this._adjustmentSaveDebouncers.values()].map(save => save.flush()),
        this._excelNotesPending ? this._excelNotesSaver.flush() : undefined,
      ]);
      return !results.includes(false);
    },
    modelMatchesActiveTab(model) {
      switch (this.activeTab) {
        case 'studio':
          return ['Morning', 'Evening', 'Night'].includes(model.location);
        case 'morning':
          return model.location === 'Morning';
        case 'evening':
          return model.location === 'Evening';
        case 'night':
          return model.location === 'Night';
        case 'satellite':
          return model.location === 'Satellite';
        case 'active':
          return true;
        default:
          return true;
      }
    },
    hasVisibleAdjustments(model) {
      return Array.isArray(model?.adjustments) && model.adjustments.some(adj => !adj.nextPeriod);
    },
    stringToDate(dateStr) {
      const cleanDate = this.formatPeriodDateLabel(dateStr);
      if (!cleanDate || typeof cleanDate !== 'string') return new Date();
      const [year, month, day] = cleanDate.split('-').map(Number);
      if (!year || !month || !day) return new Date();
      const date = new Date(year, month - 1, day);
      return isNaN(date.getTime()) ? new Date() : date;
    },
    dateToString(date) {
      if (!(date instanceof Date) || isNaN(date.getTime())) return new Date().toISOString().split('T')[0];
      return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
    },
    formatPeriodDateLabel(dateValue) {
      if (!dateValue) return '';
      if (typeof dateValue === 'string') return dateValue.split('T')[0];
      if (dateValue instanceof Date && !isNaN(dateValue.getTime())) {
        return this.dateToString(dateValue);
      }
      return String(dateValue);
    },
    parseLocalDate(dateValue) {
      const dateStr = this.formatPeriodDateLabel(dateValue);
      if (!dateStr) return null;
      const [year, month, day] = dateStr.split('-').map(Number);
      if (!year || !month || !day) return null;
      const date = new Date(year, month - 1, day);
      return isNaN(date.getTime()) ? null : date;
    },
    getExcelSendDate(paymentDate) {
      const date = this.parseLocalDate(paymentDate);
      if (!date) return null;
      date.setDate(date.getDate() - 2);
      return date;
    },
    formatShortDate(date) {
      if (!(date instanceof Date) || isNaN(date.getTime())) return '';
      return date.toLocaleDateString('en-US', {
        month: 'short',
        day: 'numeric'
      });
    },
    formatPrettyDate(dateValue) {
      const date = this.parseLocalDate(dateValue);
      if (!date) return '';
      return date.toLocaleDateString('en-US', {
        month: 'short',
        day: 'numeric',
        year: 'numeric'
      });
    },
    getSendReminderDaysLabel(paymentDate) {
      const sendDate = this.getExcelSendDate(paymentDate);
      if (!sendDate) return 'Pending';

      const today = new Date();
      const todayOnly = new Date(today.getFullYear(), today.getMonth(), today.getDate());
      const diffDays = Math.ceil((sendDate - todayOnly) / 86400000);

      if (diffDays > 1) return `${diffDays} days`;
      if (diffDays === 1) return 'Tomorrow';
      if (diffDays === 0) return 'Today';
      return 'Completed';
    },
    getSendReminderDateLabel(paymentDate) {
      const sendDate = this.getExcelSendDate(paymentDate);
      if (!sendDate) return '';
      return `(${this.formatShortDate(sendDate)})`;
    },
    getSendReminderLabel(paymentDate) {
      const sendDate = this.getExcelSendDate(paymentDate);
      if (!sendDate) return 'Send report: pending date';

      const today = new Date();
      const todayOnly = new Date(today.getFullYear(), today.getMonth(), today.getDate());
      const diffDays = Math.ceil((sendDate - todayOnly) / 86400000);
      const sendLabel = this.formatShortDate(sendDate);

      if (diffDays > 1) return `${diffDays} days to send report (${sendLabel})`;
      if (diffDays === 1) return `Send report tomorrow (${sendLabel})`;
      if (diffDays === 0) return `Send report today (${sendLabel})`;
      return `Completed (${sendLabel})`;
    },
    getSendReminderClass(paymentDate) {
      const sendDate = this.getExcelSendDate(paymentDate);
      if (!sendDate) return 'is-muted';

      const today = new Date();
      const todayOnly = new Date(today.getFullYear(), today.getMonth(), today.getDate());
      const diffDays = Math.ceil((sendDate - todayOnly) / 86400000);

      if (diffDays < 0) return 'is-completed';
      if (diffDays <= 1) return 'is-due';
      return 'is-upcoming';
    },
    updateDateValue(modelIndex, adjIndex, dateValue) {
      const id = this.filteredModels[modelIndex].id;
      const index = this.findModelIndex(id);
      if (index === -1) return;
      const dateObj = new Date(dateValue);
      this.models[index].adjustments[adjIndex].date = dateObj;
    },
    formatAmount(item) {
      let value = item.amount || '';
      if (!value) {
        item.amount = item.currency === 'COP' ? '0' : '0.00';
        return;
      }
      value = value.replace(/[^0-9.]/g, '');
      if (item.currency === 'COP') {
        const parts = value.replace(/,/g, '').split('.');
        const integerPart = parts[0];
        const decimalPart = parts[1] ? `.${parts[1].slice(0, 2)}` : '';
        item.amount = `${integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}${decimalPart}`;
      } else {
        const parts = value.split('.');
        const integerPart = parts[0].replace(/\D/g, '');
        const decimalPart = parts[1] ? parts[1].slice(0, 2).replace(/\D/g, '') : '';
        item.amount = decimalPart ? `${integerPart}.${decimalPart}` : integerPart;
      }
    },
    parseAmountForSave(value, currency) {
      if (!value) return 0;
      return currency === 'COP' ? parseFloat(value.replace(/,/g, '')) || 0 : parseFloat(value) || 0;
    },
    rehydrateModelAdjustmentsFromSave(model, savedAdjustments) {
      const rows = Array.isArray(savedAdjustments) ? savedAdjustments : [];
      model.adjustments = rows
        .map((adj) => ({
          id: adj.id,
          type: adj.type === 'Bonus' ? 'Site Bonus' : adj.type,
          amount: adj.currency === 'COP'
            ? (parseFloat(adj.amount) || 0).toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 2 })
            : (parseFloat(adj.amount) || 0).toFixed(2),
          currency: adj.currency,
          commission_percent: adj.commission_percent !== null && adj.commission_percent !== undefined
            ? Number(adj.commission_percent)
            : null,
          description: adj.description || '',
          inventory_item_id: Number(adj.inventory_item_id) || null,
          inventory_unit_price: null,
          inventory_menu_open: false,
          recovery_menu_open: false,
          recovery_type: adj.recovery_type || null,
          recovery_source: adj.recovery_source || null,
          cash_box_entry_id: Number(adj.cash_box_entry_id) || null,
          inventory_quantity: Math.max(1, Number(adj.inventory_quantity || 1)),
          inventory_stock_applied: adj.inventory_stock_applied !== false,
          site: this.normalizeSiteValue(adj.site, model),
          number: parseInt(adj.number) || 1,
          quotas: parseInt(adj.quotas) || 1,
          date: this.stringToDate(adj.date),
          observation: adj.observation || '',
          nextPeriod: Boolean(adj.nextPeriod),
          insufficientFunds: Boolean(adj.insufficientFunds),
          card_expense_id: Number(adj.card_expense_id) || null,
          payout_status: adj.payout_status || 'confirmed',
          isNew: false,
          isEdited: false,
          retention_flag: model.retention_flag
        }))
        .sort((a, b) => new Date(a.date) - new Date(b.date));
    },
    normalizeSiteValue(siteValue, fallbackModel = null) {
      const map = {
        F4F: 'Flirt4Free',
        SM: 'Streamate',
        LJ: 'LiveJasmin',
        SC: 'Stripchat',
        CB: 'Chaturbate',
        FLIRT4FREE: 'Flirt4Free',
        STREAMATE: 'Streamate',
        LIVEJASMIN: 'LiveJasmin',
        STRIPCHAT: 'Stripchat',
        CHATURBATE: 'Chaturbate',
        KW: 'Kwiky',
        KWIKY: 'Kwiky',
        SINPARTY: 'Sin Party',
        'SIN PARTY': 'Sin Party',
        CAMS: 'Cams',
        STREAMRAY: 'Cams',
        CAM4: 'Cam4',
        BONGA: 'Bonga'
      };
      const raw = String(siteValue || '').trim();
      if (raw) {
        const normalized = map[raw.toUpperCase()];
        if (normalized) return normalized;
      }
      return this.getDefaultSiteForModel(fallbackModel);
    },
    getDefaultSiteForModel(model) {
      if (!model) return 'Flirt4Free';
      const pageSource =
        model.pagina ||
        model.paginaAjuste ||
        model.page ||
        model.website ||
        model.source ||
        model.default_page ||
        model.defaultPage ||
        model.defaultSite ||
        '';
      return this.normalizeSiteValue(pageSource || 'Flirt4Free');
    },
    normalizeKnownSite(siteValue) {
      const map = {
        F4F: 'Flirt4Free',
        SM: 'Streamate',
        LJ: 'LiveJasmin',
        SC: 'Stripchat',
        CB: 'Chaturbate',
        FLIRT4FREE: 'Flirt4Free',
        STREAMATE: 'Streamate',
        LIVEJASMIN: 'LiveJasmin',
        STRIPCHAT: 'Stripchat',
        CHATURBATE: 'Chaturbate',
        KW: 'Kwiky',
        KWIKY: 'Kwiky',
        SINPARTY: 'Sin Party',
        'SIN PARTY': 'Sin Party',
        CAMS: 'Cams',
        STREAMRAY: 'Cams',
        CAM4: 'Cam4',
        BONGA: 'Bonga'
      };
      const raw = String(siteValue || '').trim().toUpperCase();
      return raw ? (map[raw] || null) : null;
    },
    isCbSiteValue(siteValue, fallbackModel = null) {
      return ['Chaturbate', 'Cam4'].includes(this.normalizeSiteValue(siteValue, fallbackModel));
    },
    toDisplaySubsidy(dbValue) {
      const raw = String(dbValue || 'None').trim();
      if (raw === 'Full') return 'Full - Main';
      if (raw === 'Half') return 'Half - Main';
      if (raw === 'Full - CB') return 'Full - CB';
      if (raw === 'Half - CB') return 'Half - CB';
      return 'None';
    },
    toDbSubsidy(displayValue) {
      const raw = String(displayValue || 'None').trim();
      if (raw === 'Full - Main') return 'Full';
      if (raw === 'Half - Main') return 'Half';
      if (raw === 'Full - CB') return 'Full - CB';
      if (raw === 'Half - CB') return 'Half - CB';
      return 'None';
    },
    getDefaultSiteForNewAdjustment(model) {
      const fallbackSite = this.getDefaultSiteForModel(model);
      const entries = Array.isArray(model?.siteEarnings) ? model.siteEarnings : [];
      if (entries.length === 0) return fallbackSite;

      let highest = null;
      entries.forEach((entry) => {
        const site = this.normalizeKnownSite(entry?.site);
        const gross = Number(entry?.gross);
        if (!site || !Number.isFinite(gross)) return;
        if (!highest || gross > highest.gross) {
          highest = { site, gross };
        }
      });

      if (highest && highest.gross >= 100) {
        return highest.site;
      }
      return fallbackSite;
    },
    getSiteCode(site) {
      const studioCode = String(site || '').trim().toUpperCase();
      if (['CC', 'CJ', 'BOG', 'PEI'].includes(studioCode)) return studioCode;
      const normalized = this.normalizeSiteValue(site);
      const codeMap = {
        Flirt4Free: 'F4F',
        Streamate: 'SM',
        LiveJasmin: 'LJ',
        Stripchat: 'SC',
        Chaturbate: 'CB',
        Kwiky: 'KWK',
        'Sin Party': 'SP',
        Cams: 'CAMS',
        Cam4: 'CAM4',
        Bonga: 'BONGA'
      };
      return codeMap[normalized] || normalized;
    },
    formatGrossForSiteLabel(value) {
      const n = Number(value || 0);
      return new Intl.NumberFormat('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(Number.isFinite(n) ? n : 0);
    },
    getSiteOptionsForModel(model) {
      const entries = Array.isArray(model?.siteEarnings) ? model.siteEarnings : [];
      const options = entries
        .map((entry) => {
          const site = this.normalizeSiteValue(entry.site, model);
          const gross = Number(entry.gross || 0);
          const siteCode = this.getSiteCode(site);
          return {
            value: site,
            gross,
            label: siteCode,
            menuLabel: `${siteCode} — $${this.formatGrossForSiteLabel(gross)}`
          };
        })
        .filter((entry) => entry.gross > 0);

      if (options.length > 0) return options;

      // Fallback: never allow an empty dropdown.
      const fallbackSite = this.getDefaultSiteForModel(model);
      return [{
        value: fallbackSite,
        label: this.getSiteCode(fallbackSite),
        menuLabel: `${this.getSiteCode(fallbackSite)} — $${this.formatGrossForSiteLabel(0)}`
      }];
    },

    getSubsidyOptionsForModel(model) {
      const earnings = Array.isArray(model?.siteEarnings) ? model.siteEarnings : [];

      const hasMain = earnings.some(e =>
        ['Flirt4Free', 'Streamate', 'LiveJasmin', 'Stripchat', 'Kwiky', 'Sin Party', 'Cams', 'Bonga'].includes(e.site) && Number(e.gross || 0) > 0
      );

      const hasCB = earnings.some(e => ['Chaturbate', 'Cam4'].includes(e.site) && Number(e.gross || 0) > 0);

      // CB-only model: only allow CB subsidy choices.
      if (hasCB && !hasMain) {
        return ['Full - CB', 'Half - CB', 'None'];
      }

      // Main-only model (or no earnings yet): only allow Main subsidy choices.
      if (!hasCB) {
        return ['Full - Main', 'Half - Main', 'None'];
      }

      // Mixed model: allow both Main and CB choices.
      return this.subsidyOptions;
    },
    async saveSatelliteRateType(model) {
      if (!model || model.location !== 'Satellite' || !this.canEditModel(model)) return;
      const previousValue = model.satellite_rate_type === 'Fixed' ? 'Scale' : 'Fixed';
      try {
        const response = await secureAxios.patch(`/api/models/${model.id}/satellite-rate-type`, {
          satellite_rate_type: model.satellite_rate_type,
        });
        model.satellite_rate_type = response.data?.satellite_rate_type || model.satellite_rate_type;
        this.applyAutomaticSatellitePercentage(model);
        this.debounceSave(model.id);
        toast.success(`${model.stageName || model.fullName} is now ${model.satellite_rate_type}`);
      } catch (error) {
        model.satellite_rate_type = previousValue;
        toast.error(error.response?.data?.message || 'Unable to save the Satellite rate type');
      }
    },
    hasSatellitePercentageOverride(model) {
      return model?.location === 'Satellite'
        && model.percentage_override !== null
        && model.percentage_override !== undefined
        && model.percentage_override !== '';
    },
    calculateSatellitePercentage(model) {
      if (String(model?.satellite_rate_type || '').toLowerCase() === 'fixed') return 80;
      const hours = Number(model?.hours || 0);
      if (hours >= 60) return 90;
      if (hours >= 45) return 85;
      return 70;
    },
    applyAutomaticSatellitePercentage(model) {
      if (!model || model.location !== 'Satellite' || this.hasSatellitePercentageOverride(model)) return;
      const percentage = this.calculateSatellitePercentage(model);
      model.percentage_auto = percentage;
      model.percentage = percentage;
    },
    handleSatelliteHoursInput(model, value) {
      if (!model || model.location !== 'Satellite' || !this.canEditModel(model)) return;
      const raw = String(value ?? '').trim();
      const parsed = Number(raw);
      if (!raw) {
        model.hours_override = null;
        model.hours = model.calculated_hours ?? '';
      } else if (Number.isFinite(parsed)) {
        model.hours_override = Math.max(0, Math.min(999.99, parsed));
      } else {
        return;
      }
      this.applyAutomaticSatellitePercentage(model);
      this.debounceSave(model.id);
    },
    handleSatellitePercentageInput(model, value) {
      if (!model || model.location !== 'Satellite' || !this.canEditModel(model)) return;
      const raw = String(value ?? '').trim();
      const parsed = Number(raw);
      if (!raw) {
        model.percentage_override = null;
        this.applyAutomaticSatellitePercentage(model);
      } else if (Number.isFinite(parsed)) {
        model.percentage_override = Math.max(0, Math.min(100, parsed));
        model.percentage = model.percentage_override;
      } else {
        return;
      }
      this.debounceSave(model.id);
    },
    hasPositiveMainSiteEarnings(model) {
      const earnings = Array.isArray(model?.siteEarnings) ? model.siteEarnings : [];
      const mainSites = new Set(['Flirt4Free', 'Streamate', 'LiveJasmin', 'Stripchat', 'Kwiky', 'Sin Party', 'Cams', 'Bonga']);
      return earnings.some((entry) =>
        mainSites.has(this.normalizeSiteValue(entry?.site, model)) && Number(entry?.gross || 0) > 0
      );
    },
    isCbSubsidySelection(value) {
      const raw = String(value || '').trim();
      return raw === 'Full - CB' || raw === 'Half - CB';
    },
    toMainSubsidySelection(value) {
      const raw = String(value || '').trim();
      if (raw === 'Full - CB') return 'Full - Main';
      if (raw === 'Half - CB') return 'Half - Main';
      return raw || 'None';
    },
    handleSubsidySelection(model, selectedValue) {
      if (!model?.id) return;
      if (this.isCbSubsidySelection(selectedValue) && this.hasPositiveMainSiteEarnings(model)) {
        this.subsidyConfirm = {
          open: true,
          modelId: model.id,
          pendingValue: selectedValue
        };
        return;
      }
      this.debounceSave(model.id);
    },
    confirmSubsidyUseCb() {
      const modelIndex = this.findModelIndex(this.subsidyConfirm.modelId);
      if (modelIndex !== -1) {
        this.models[modelIndex].subsidy = this.subsidyConfirm.pendingValue;
        this.debounceSave(this.models[modelIndex].id);
      }
      this.subsidyConfirm = { open: false, modelId: null, pendingValue: 'None' };
    },
    confirmSubsidyUseMain() {
      const modelIndex = this.findModelIndex(this.subsidyConfirm.modelId);
      if (modelIndex !== -1) {
        const mainSubsidy = this.toMainSubsidySelection(this.subsidyConfirm.pendingValue);
        this.models[modelIndex].subsidy = mainSubsidy;
        this.debounceSave(this.models[modelIndex].id);
      }
      this.subsidyConfirm = { open: false, modelId: null, pendingValue: 'None' };
    },
    openQuotasEditor(modelId, adjIndex, item) {
      if (!item?.isNew) return;
      this.quotasEditor = {
        open: true,
        modelId,
        adjIndex,
        current: Number(item.number) || 1,
        total: Number(item.quotas) || 1
      };
    },
    closeQuotasEditor() {
      this.quotasEditor.open = false;
      this.quotasEditor.modelId = null;
      this.quotasEditor.adjIndex = null;
    },
    saveQuotasEditor() {
      const { modelId, adjIndex } = this.quotasEditor;
      const modelIndex = this.findModelIndex(modelId);
      if (modelIndex === -1 || adjIndex === null || adjIndex === undefined) {
        this.closeQuotasEditor();
        return;
      }
      const model = this.models[modelIndex];
      const adj = model?.adjustments?.[adjIndex];
      if (!adj) {
        this.closeQuotasEditor();
        return;
      }

      const total = Math.max(1, Number(this.quotasEditor.total) || 1);
      const current = Math.min(total, Math.max(1, Number(this.quotasEditor.current) || 1));
      adj.number = current;
      adj.quotas = total;
      this.markAdjustmentAsEdited(modelId, adjIndex);
      this.closeQuotasEditor();
    },
    async fetchPeriods() {
      try {
        const response = await secureAxios.get('/api/adjustments/periods');

        // Normalize payment_date coming from backend (avoid selecting the first period when the field is missing)
        this.periods = (response.data || []).map(p => ({
          ...p,
          payment_date: p.payment_date || p.paymentDate || p.paymentDateStr || p.payment_date_str || '1970-01-01',
          cb_payment_date: p.cb_payment_date || p.cbPaymentDate || p.cb_payment_date_str || p.cbPaymentDateStr || null
        }));

        // Sort ascending by payment date
        this.periods.sort((a, b) => this.stringToDate(a.payment_date) - this.stringToDate(b.payment_date));

        // Build TODAY as local calendar date (YYYY-MM-DD)
        const today = new Date();
        const todayStr =
          `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, '0')}-${String(today.getDate()).padStart(2, '0')}`;

        let selected = null;

        for (const period of this.periods) {
          if (!period.payment_date) continue;

          // Normalize payment_date as a calendar date, not a UTC timestamp.
          const paymentStr = this.formatPeriodDateLabel(period.payment_date);
          if (!paymentStr) continue;

          // Cutoff = payment_date + 1 calendar day
          const [y, m, d] = paymentStr.split('-').map(Number);
          const cutoff = new Date(y, m - 1, d + 1);
          const cutoffStr =
            `${cutoff.getFullYear()}-${String(cutoff.getMonth() + 1).padStart(2, '0')}-${String(cutoff.getDate()).padStart(2, '0')}`;

          if (todayStr < cutoffStr) {
            selected = period;
            break;
          }
        }

        this.selectedPeriod = selected
          ? selected.id
          : this.periods[this.periods.length - 1].id;
        await this.fetchModels();
      } catch (error) {
        console.error('❌ Error fetching periods:', error?.message || error);
        toast.error('Failed to fetch periods');
      }
    },
    async fetchModels() {
      if (!this.selectedPeriod) return;
      try {
        const response = await secureAxios.get('/api/adjustments/models', {
          params: { periodId: this.selectedPeriod }
        });
        this.models = response.data.models.map(model => {
          const defaultSite = this.getDefaultSiteForModel(model);
          // Process adjustments and add retention_flag to each adjustment
          const adjustments = (model.adjustments || []).map(adj => ({
            id: adj.id,
            type: adj.type === 'Bonus' ? 'Site Bonus' : adj.type,
            amount: adj.currency === 'COP' 
              ? (parseFloat(adj.amount) || 0).toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 2 })
              : (parseFloat(adj.amount) || 0).toFixed(2),
            currency: adj.currency,
            description: adj.description || '',
            inventory_item_id: Number(adj.inventory_item_id) || null,
            inventory_unit_price: null,
            inventory_menu_open: false,
            recovery_menu_open: false,
            recovery_type: adj.recovery_type || null,
            recovery_source: adj.recovery_source || null,
            cash_box_entry_id: Number(adj.cash_box_entry_id) || null,
            inventory_quantity: Math.max(1, Number(adj.inventory_quantity || 1)),
            inventory_stock_applied: adj.inventory_stock_applied !== false,
            site: this.normalizeSiteValue(adj.site, model),
            number: parseInt(adj.number) || 1,
            quotas: parseInt(adj.quotas) || 1,
            date: this.stringToDate(adj.date),
            observation: adj.observation || '',
            nextPeriod: Boolean(adj.nextPeriod),
            insufficientFunds: Boolean(adj.insufficientFunds),
            card_expense_id: Number(adj.card_expense_id) || null,
            payout_status: adj.payout_status || 'confirmed',
            isNew: false,
            isEdited: false
          })).sort((a, b) => new Date(a.date) - new Date(b.date));
          // Add retention_flag from model to each adjustment
          adjustments.forEach(adj => {
            adj.retention_flag = model.retention_flag;
          });
          return {
            id: model.id,
            adjustments_id: model.adjustments_id,
            period_id: model.period_id,
            studio_id: model.studio_id,
            isLocked: Boolean(model.isLocked),
            fullName: model.fullName || 'Unknown',
            stageName: model.stageName || '',
            location: model.location || 'Unknown',
            status: model.status || 'Inactive',
            retention_status: model.retention_status ?? 'No',
            retention_flag: model.retention_flag, // keep the flag at model level too
            subsidy: this.toDisplaySubsidy(model.subsidy),
            satellite_rate_type: model.satellite_rate_type || 'Scale',
            hours: model.hours ?? '',
            percentage: model.percentage ?? 50,
            calculated_hours: model.calculated_hours ?? '',
            hours_override: model.hours_override !== null && model.hours_override !== undefined
              ? Number(model.hours_override)
              : null,
            percentage_auto: model.percentage_auto ?? model.percentage ?? 50,
            percentage_override: model.percentage_override !== null && model.percentage_override !== undefined
              ? Number(model.percentage_override)
              : null,
            classes: model.classes ?? 0,
            defaultSite,
            resolvedMainSubsidySite: this.normalizeSiteValue(model.resolvedMainSubsidySite, model),
            siteEarnings: Array.isArray(model.siteEarnings)
              ? model.siteEarnings.map((entry) => ({
                  site: this.normalizeSiteValue(entry.site, model),
                  gross: Number(entry.gross || 0)
                }))
              : [],
            adjustments
          };
        });
        this.mainExcelNote = response.data.periodNotes?.main_note || '';
        this.cbExcelNote = response.data.periodNotes?.cb_note || '';
        this.isPeriodLocked = response.data.isLocked;
        this.lockedByStudio = response.data.lockedByStudio || {};
        this.isAdmin = response.data.isAdmin || false;
        await this.fetchInventoryItems();
        await this.fetchPending();
        await this.fetchStudioUses();
        await this.fetchDirectSales();
        await this.fetchExportStatus();
        return true;
      } catch (error) {
        console.error('❌ Error fetching models:', error?.message || error);
        toast.error('Failed to fetch models');
        return false;
      }
    },
    async fetchInventoryItems() {
      try {
        const studioIds = this.isSatelliteMonitor
          ? [...new Set(this.models.map((model) => Number(model.studio_id)).filter((id) => id > 0))]
          : [Number(this.user?.studio_id)].filter((id) => id > 0);
        const responses = await Promise.all(studioIds.map((studioId) => (
          secureAxios.get('/api/inventory/items', {
            params: this.isSatelliteMonitor ? { studio_id: studioId } : undefined,
          })
        )));
        this.inventoryItems = responses.flatMap((response, index) => (
          (response.data || []).map((item) => ({ ...item, studio_id: studioIds[index] }))
        ));
        this.hydrateAcceptedInventoryPricing();
      } catch (error) {
        console.error('Error loading adjustment inventory choices:', error?.message || error);
        this.inventoryItems = [];
      }
    },
    hydrateAcceptedInventoryPricing() {
      this.models.forEach((model) => {
          model.adjustments.forEach((adjustment) => {
            const selected = this.inventoryItems.find((item) => (
              Number(item.id) === Number(adjustment.inventory_item_id)
              && Number(item.studio_id) === Number(model.studio_id)
            ));
            adjustment.inventory_unit_price = selected ? Number(selected.default_selling_price || 0) : null;
          });
        });
    },
    acceptedInventoryOptions(model) {
      return this.inventoryItems.filter((item) => (
        Number(item.studio_id) === Number(model.studio_id)
        && Number(item.quantity_on_hand || 0) >= 1
      ));
    },
    filteredAcceptedInventoryOptions(model, adjustment) {
      const search = String(adjustment.description || '').trim().toLowerCase();
      const choices = this.acceptedInventoryOptions(model);
      if (!search) return choices.slice(0, 12);
      return choices
        .filter((item) => String(item.name || '').toLowerCase().includes(search))
        .slice(0, 12);
    },
    handleAcceptedDescription(model, adjustment, adjIndex, value) {
      adjustment.description = String(value || '');
      const normalized = adjustment.description.trim().toLowerCase();
      const matches = this.acceptedInventoryOptions(model).filter(
        (item) => String(item.name || '').trim().toLowerCase() === normalized
      );
      adjustment.inventory_item_id = matches.length === 1 ? Number(matches[0].id) : null;
      adjustment.inventory_unit_price = matches.length === 1
        ? Number(matches[0].default_selling_price || 0)
        : null;
      if (matches.length === 1 && this.parseAmountForSave(adjustment.amount, adjustment.currency) <= 0) {
        adjustment.amount = String(adjustment.inventory_unit_price * Math.max(1, Number(adjustment.inventory_quantity || 1)));
        adjustment.currency = 'COP';
        this.formatAmount(adjustment);
      }
      adjustment.inventory_menu_open = !!adjustment.description;
      this.markAdjustmentAsEdited(model.id, adjIndex);
    },
    selectAcceptedInventoryItem(model, adjustment, adjIndex, inventoryItem) {
      adjustment.description = inventoryItem.name;
      adjustment.inventory_item_id = Number(inventoryItem.id);
      adjustment.inventory_unit_price = Number(inventoryItem.default_selling_price || 0);
      adjustment.amount = String(adjustment.inventory_unit_price * Math.max(1, Number(adjustment.inventory_quantity || 1)));
      adjustment.currency = 'COP';
      adjustment.inventory_menu_open = false;
      this.formatAmount(adjustment);
      this.markAdjustmentAsEdited(model.id, adjIndex);
    },
    handleAcceptedQuantityChange(model, adjustment, adjIndex, value) {
      const quantity = Math.max(1, Number.parseInt(value, 10) || 1);
      adjustment.inventory_quantity = quantity;
      if (adjustment.inventory_item_id && Number(adjustment.inventory_unit_price || 0) > 0) {
        adjustment.amount = String(Number(adjustment.inventory_unit_price) * quantity);
        adjustment.currency = 'COP';
        this.formatAmount(adjustment);
      }
      this.markAdjustmentAsEdited(model.id, adjIndex);
    },
    handleAcceptedTypeChange(model, adjustment, adjIndex) {
      if (adjustment.type !== 'Purchase') {
        adjustment.inventory_item_id = null;
        adjustment.inventory_unit_price = null;
        adjustment.inventory_menu_open = false;
      }
      if (adjustment.type !== 'Discount' && !adjustment.card_expense_id && !adjustment.cash_box_entry_id) {
        adjustment.recovery_type = null;
        adjustment.recovery_source = null;
        adjustment.recovery_menu_open = false;
      }
      this.markAdjustmentAsEdited(model.id, adjIndex);
    },
    filteredRecoveryDescriptions(adjustment) {
      const options = [
        { title: 'Adelanto de Pago (Card)', value: 'Adelanto', source: 'card_expense' },
        { title: 'Préstamo (Card)', value: 'Prestamo', source: 'card_expense' },
        { title: 'Adelanto de Pago (Cash)', value: 'Adelanto', source: 'cash_box' },
        { title: 'Préstamo (Cash)', value: 'Prestamo', source: 'cash_box' }
      ];
      const search = this.normalizeSearchText(adjustment?.description || '');
      if (!search) return options;
      return options.filter((option) => this.normalizeSearchText(option.title).includes(search));
    },
    looksLikeRecoveryDescription(description) {
      const normalized = this.normalizeSearchText(description);
      return normalized.includes('adel') || normalized.includes('presta');
    },
    handleDiscountDescriptionInput(model, adjustment, adjIndex, value) {
      adjustment.description = String(value || '');
      if (!adjustment.card_expense_id && !adjustment.cash_box_entry_id) {
        adjustment.recovery_type = null;
        adjustment.recovery_source = null;
      }
      adjustment.recovery_menu_open = true;
      this.markAdjustmentAsEdited(model.id, adjIndex);
    },
    selectRecoveryDescription(model, adjustment, adjIndex, option) {
      adjustment.description = option.value === 'Adelanto' ? 'Adelanto de Pago' : 'Préstamo';
      adjustment.recovery_type = option.value;
      adjustment.recovery_source = option.source;
      adjustment.recovery_menu_open = false;
      adjustment.currency = 'COP';
      if (option.value === 'Adelanto') {
        adjustment.number = 1;
        adjustment.quotas = 1;
      }
      this.markAdjustmentAsEdited(model.id, adjIndex);
    },
    formatAmountLabel(value) {
      return new Intl.NumberFormat('es-CO', {
        style: 'currency', currency: 'COP', maximumFractionDigits: 0,
      }).format(Number(value || 0));
    },
    addDirectSale() {
      this.directSales.push(createDirectSaleRow());
    },
    sendPendingToDirectSales(item) {
      if (!this.canEdit || item.type !== 'Purchase' || !Number(item.inventory_item_id)) return;

      const existingDraft = this.directSales.find(
        (sale) => Number(sale.sourcePendingId) === Number(item.id) && !sale.recorded
      );
      if (existingDraft) {
        this.$nextTick(() => this.$refs.directSalesSection?.scrollIntoView({ behavior: 'smooth', block: 'start' }));
        toast.info('This pending purchase is already prepared in Direct Sales');
        return;
      }

      const inventoryItem = this.inventoryItems.find(
        (candidate) => Number(candidate.id) === Number(item.inventory_item_id)
          && Number(candidate.studio_id) === Number(item.studio_id)
      ) || this.inventoryItems.find(
        (candidate) => Number(candidate.id) === Number(item.inventory_item_id)
      );
      const quantity = Math.max(1, Number(item.inventory_quantity || 1));
      const sale = createDirectSaleRow();
      sale.sourcePendingId = Number(item.id);
      sale.buyerName = this.pendingFullName(item) === '—'
        ? String(item.model_name || '').trim()
        : this.pendingFullName(item);
      sale.itemId = Number(item.inventory_item_id);
      sale.itemName = inventoryItem?.name || String(item.description || '').trim();
      sale.unitPrice = Number(inventoryItem?.default_selling_price || 0);
      sale.quantity = quantity;
      sale.saleTotal = String(this.parseAmountForSave(String(item.amount || '0'), item.currency || 'COP'));
      sale.paymentMethod = 'Cash';
      sale.saleDate = this.stringToDate(item.report_date);
      this.formatDirectSalePrice(sale);
      this.directSales.push(sale);

      this.$nextTick(() => this.$refs.directSalesSection?.scrollIntoView({ behavior: 'smooth', block: 'start' }));
      toast.info('Direct sale prepared below. Review it and press Save');
    },
    removeDirectSale(id) {
      this.directSales = this.directSales.filter((sale) => sale.id !== id);
    },
    editDirectSale(sale) {
      sale.recorded = false;
      sale.isEditing = true;
    },
    directSaleInventoryOptions() {
      const studioId = Number(this.user?.studio_id);
      const studioItems = this.inventoryItems.filter((item) => (
        !studioId || Number(item.studio_id) === studioId
      ));
      return studioItems.filter((item) => Number(item.quantity_on_hand || 0) >= 1);
    },
    filteredDirectSaleItems(sale) {
      const search = String(sale.itemName || '').trim().toLowerCase();
      const choices = this.directSaleInventoryOptions();
      if (!search) return choices.slice(0, 12);
      return choices
        .filter((item) => String(item.name || '').toLowerCase().includes(search))
        .slice(0, 12);
    },
    handleDirectSaleItemInput(sale, value) {
      sale.itemName = String(value || '');
      const normalized = sale.itemName.trim().toLowerCase();
      const matches = this.directSaleInventoryOptions().filter(
        (item) => String(item.name || '').trim().toLowerCase() === normalized
      );
      sale.itemId = matches.length === 1 ? Number(matches[0].id) : null;
      sale.unitPrice = matches.length === 1 ? Number(matches[0].default_selling_price || 0) : 0;
      if (matches.length === 1 && this.parseAmountForSave(sale.saleTotal, 'COP') <= 0) {
        sale.saleTotal = String(sale.unitPrice * Math.max(1, Number(sale.quantity || 1)));
        this.formatDirectSalePrice(sale);
      }
      sale.itemMenuOpen = !!sale.itemName;
    },
    selectDirectSaleItem(sale, inventoryItem) {
      sale.itemId = Number(inventoryItem.id);
      sale.itemName = inventoryItem.name;
      sale.unitPrice = Number(inventoryItem.default_selling_price || 0);
      sale.saleTotal = String(sale.unitPrice * Math.max(1, Number(sale.quantity || 1)));
      sale.itemMenuOpen = false;
      this.formatDirectSalePrice(sale);
    },
    handleDirectSaleQuantity(sale, value) {
      sale.quantity = Math.max(1, Number.parseInt(value, 10) || 1);
      if (sale.itemId && Number(sale.unitPrice || 0) > 0) {
        sale.saleTotal = String(Number(sale.unitPrice) * sale.quantity);
        this.formatDirectSalePrice(sale);
      }
    },
    formatDirectSalePrice(sale) {
      sale.saleTotal = String(this.parseAmountForSave(String(sale.saleTotal || '0'), 'COP'));
      const amountProxy = { amount: sale.saleTotal, currency: 'COP' };
      this.formatAmount(amountProxy);
      sale.saleTotal = amountProxy.amount;
    },
    canSaveDirectSale(sale) {
      return !sale.recorded
        && this.canEdit
        && !!String(sale.buyerName || '').trim()
        && Number(sale.itemId) > 0
        && Number(sale.quantity) > 0
        && this.parseAmountForSave(String(sale.saleTotal || ''), 'COP') > 0
        && !!sale.paymentMethod
        && !!sale.saleDate;
    },
    async saveDirectSale(sale) {
      if (!this.canSaveDirectSale(sale)) return;
      sale.saving = true;
      const wasEditing = sale.isEditing;
      try {
        const payload = {
          buyerName: String(sale.buyerName).trim(),
          itemId: Number(sale.itemId),
          quantity: Math.max(1, Number(sale.quantity || 1)),
          saleTotal: this.parseAmountForSave(String(sale.saleTotal), 'COP'),
          paymentMethod: sale.paymentMethod,
          saleDate: this.dateToString(sale.saleDate),
          periodId: this.selectedPeriod,
          pendingAdjustmentId: Number(sale.sourcePendingId) || null,
        };
        const isPendingTransfer = !wasEditing && Number(sale.sourcePendingId) > 0;
        const response = wasEditing
          ? await secureAxios.put(`/api/inventory/direct-sales/${sale.id}`, payload)
          : await secureAxios.post(
            isPendingTransfer ? '/api/inventory/direct-sales/from-pending' : '/api/inventory/direct-sales',
            payload
          );
        sale.id = Number(response.data?.id) || sale.id;
        sale.recorded = true;
        sale.isEditing = false;
        sale.itemMenuOpen = false;
        await this.fetchInventoryItems();
        if (isPendingTransfer) await this.fetchPending();
        toast.success(wasEditing ? 'Direct sale updated' : response.data?.message || 'Direct sale recorded');
      } catch (error) {
        toast.error(error?.response?.data?.message || 'Unable to record direct sale');
      } finally {
        sale.saving = false;
      }
    },
    openDirectSaleObservation(sale) {
      this.directSaleObservation = {
        open: true,
        sale,
        notes: sale.notes || '',
        saving: false,
      };
    },
    async saveDirectSaleObservation() {
      const state = this.directSaleObservation;
      if (!state.sale?.id) return;
      state.saving = true;
      try {
        await secureAxios.patch(`/api/inventory/direct-sales/${state.sale.id}/notes`, {
          notes: state.notes,
        });
        state.sale.notes = String(state.notes || '').trim();
        state.open = false;
        toast.success('Observation saved');
      } catch (error) {
        toast.error(error?.response?.data?.message || 'Unable to save observation');
      } finally {
        state.saving = false;
      }
    },
    async deleteDirectSale(sale) {
      if (!window.confirm(`Delete the direct sale for ${sale.buyerName}? Inventory will be restored.`)) return;
      try {
        await secureAxios.delete(`/api/inventory/direct-sales/${sale.id}`);
        this.removeDirectSale(sale.id);
        await this.fetchInventoryItems();
        toast.success('Direct sale deleted and inventory restored');
      } catch (error) {
        toast.error(error?.response?.data?.message || 'Unable to delete direct sale');
      }
    },
    async fetchDirectSales() {
      if (!this.selectedPeriod) {
        this.directSales = [];
        return;
      }
      this.directSalesLoading = true;
      try {
        const response = await secureAxios.get('/api/inventory/direct-sales', {
          params: { period_id: this.selectedPeriod },
        });
        this.directSales = (response.data || []).map((sale) => ({
          id: Number(sale.id),
          buyerName: sale.buyer_name || '',
          itemId: Number(sale.item_id) || null,
          itemName: sale.item_name || '',
          itemMenuOpen: false,
          unitPrice: Number(sale.unit_price || 0),
          quantity: Math.max(1, Number(sale.quantity || 1)),
          saleTotal: Number(sale.sale_total || 0).toLocaleString('en-US', {
            minimumFractionDigits: 0,
            maximumFractionDigits: 2,
          }),
          paymentMethod: sale.payment_method || 'Cash',
          saleDate: this.stringToDate(sale.sale_date),
          saving: false,
          recorded: true,
          isEditing: false,
          notes: sale.notes || '',
          sourcePendingId: null,
        }));
      } catch (error) {
        console.error('Error loading direct sales:', error?.message || error);
        this.directSales = [];
      } finally {
        this.directSalesLoading = false;
      }
    },
    async fetchStudioUses() {
      if (!this.selectedPeriod) {
        this.studioUses = [];
        return;
      }
      try {
        const response = await secureAxios.get('/api/inventory/studio-use', {
          params: { period_id: this.selectedPeriod },
        });
        this.studioUses = (response.data || []).map((entry) => ({
          id: Number(entry.id),
          itemId: Number(entry.item_id),
          itemName: entry.item_name || '',
          quantity: Math.max(1, Number(entry.quantity || 1)),
          useDate: entry.use_date,
          notes: entry.notes || '',
          studioName: entry.studio_name || '',
        }));
      } catch (error) {
        console.error('Error loading studio use:', error?.message || error);
        this.studioUses = [];
      }
    },
    async fetchPending() {
      this.pendingLoading = true;
      try {
        const response = await secureAxios.get('/api/adjustments/pending');
        this.pendingAdjustments = (response.data || []).map((item) => {
          const normalized = {
            ...item,
            model_id: Number(item.model_id) || null,
            amount: item.currency === 'COP'
              ? Number(item.amount || 0).toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 2 })
              : Number(item.amount || 0).toFixed(2),
            quotas: Math.max(1, Number(item.quotas || 1)),
            inventory_quantity: Math.max(1, Number(item.inventory_quantity || 1)),
            inventory_unit_price: Number(item.inventory_unit_price || 0),
            site: item.site || 'Flirt4Free',
          };
          if (this.isStudioPending(normalized)) {
            normalized.site = this.getStudioPendingSiteCode(normalized);
          }
          return normalized;
        });
      } catch (error) {
        console.error('Error fetching pending adjustments:', error?.message || error);
        toast.error('Failed to load pending report adjustments');
      } finally {
        this.pendingLoading = false;
      }
    },
    setPendingModelDefaults(item) {
      const model = this.models.find((candidate) => candidate.id === item.model_id);
      if (model) item.site = this.getDefaultSiteForModel(model);
    },
    setPendingGroupModel(group, modelId) {
      group.items.forEach((item) => {
        item.model_id = Number(modelId) || null;
        this.setPendingModelDefaults(item);
      });
    },
    pendingStageName(item) {
      return this.models.find((candidate) => Number(candidate.id) === Number(item.model_id))?.stageName
        || item.stageName
        || '';
    },
    pendingFullName(item) {
      return this.models.find((candidate) => Number(candidate.id) === Number(item.model_id))?.fullName
        || item.fullName
        || item.model_name
        || '—';
    },
    isStudioPending(item) {
      const studioNames = { 1: 'Studio CC', 2: 'Studio CJ', 3: 'Studio BOG', 4: 'Studio PEI' };
      const expected = studioNames[Number(item?.studio_id || this.user?.studio_id)];
      return Boolean(expected)
        && String(item?.model_name || '').trim().toLowerCase() === expected.toLowerCase();
    },
    getStudioPendingSiteCode(item) {
      const studioCodes = { 1: 'CC', 2: 'CJ', 3: 'BOG', 4: 'PEI' };
      return studioCodes[Number(item?.studio_id || this.user?.studio_id)] || 'STUDIO';
    },
    openStudioUseDialog(itemOrItems) {
      const items = (Array.isArray(itemOrItems) ? itemOrItems : [itemOrItems])
        .filter((item) => this.isStudioPending(item));
      if (!items.length) return;
      this.studioUseDialog = {
        open: true,
        direct: false,
        items,
        itemId: null,
        quantity: 1,
        useDate: new Date(),
        notes: '',
        saving: false,
      };
    },
    openDirectStudioUseDialog() {
      if (!this.canEdit || this.isPeriodLocked) return;
      this.studioUseDialog = {
        open: true,
        direct: true,
        items: [],
        itemId: null,
        quantity: 1,
        useDate: new Date(),
        notes: '',
        saving: false,
      };
    },
    canSaveDirectStudioUse() {
      return this.canEdit
        && !this.isPeriodLocked
        && Number(this.studioUseDialog.itemId) > 0
        && Number(this.studioUseDialog.quantity) > 0
        && !!this.studioUseDialog.useDate;
    },
    async saveStudioUse() {
      const state = this.studioUseDialog;
      if (state.direct) {
        if (!this.canSaveDirectStudioUse()) return;
        state.saving = true;
        try {
          const response = await secureAxios.post('/api/inventory/studio-use', {
            itemId: Number(state.itemId),
            quantity: Math.max(1, Number.parseInt(state.quantity, 10) || 1),
            useDate: this.dateToString(state.useDate),
            periodId: Number(this.selectedPeriod),
            notes: state.notes,
          });
          state.open = false;
          await this.fetchInventoryItems();
          await this.fetchStudioUses();
          toast.success(response.data?.message || 'Studio use recorded');
        } catch (error) {
          toast.error(error?.response?.data?.message || 'Unable to record studio use');
        } finally {
          state.saving = false;
        }
        return;
      }
      const ids = state.items.map((item) => Number(item.id)).filter((id) => id > 0);
      if (!ids.length) return;
      state.saving = true;
      this.pendingActionId = ids[0];
      try {
        const response = await secureAxios.post('/api/inventory/studio-use/from-pending', {
          pendingAdjustmentIds: ids,
          periodId: Number(this.selectedPeriod),
          notes: state.notes,
        });
        const accepted = new Set(ids);
        this.pendingAdjustments = this.pendingAdjustments.filter((row) => !accepted.has(Number(row.id)));
        state.open = false;
        await this.fetchInventoryItems();
        await this.fetchStudioUses();
        toast.success(response.data?.message || 'Studio use recorded');
      } catch (error) {
        toast.error(error?.response?.data?.message || 'Unable to record studio use');
      } finally {
        state.saving = false;
        this.pendingActionId = null;
      }
    },
    getPendingSiteOptions(item) {
      if (this.isStudioPending(item)) {
        const code = this.getStudioPendingSiteCode(item);
        return [{ value: code, label: code, menuLabel: code }];
      }
      const model = this.models.find((candidate) => Number(candidate.id) === Number(item.model_id));
      return this.getSiteOptionsForModel(model);
    },
    handlePendingQuantityChange(item, value) {
      const quantity = Math.max(1, Number.parseInt(value, 10) || 1);
      item.inventory_quantity = quantity;
      const unitPrice = Number(item.inventory_unit_price || 0);
      if (item.type === 'Purchase' && item.inventory_item_id && unitPrice > 0) {
        item.amount = String(unitPrice * quantity);
        item.currency = 'COP';
        this.formatAmount(item);
      }
    },
    canApprovePending(item) {
      if (!this.canEdit || !this.selectedPeriod) return false;
      if (!String(item.description || '').trim() || this.parseAmountForSave(item.amount, item.currency) <= 0) return false;
      if (item.type === 'Purchase' && (!Number.isInteger(Number(item.inventory_quantity)) || Number(item.inventory_quantity) < 1)) return false;
      if (this.isStudioPending(item)) {
        return item.type === 'Purchase' && Number(item.inventory_item_id) > 0;
      }
      if (!item.model_id) return false;
      const model = this.models.find((candidate) => candidate.id === item.model_id);
      return !!model && !model.isLocked;
    },
    pendingApprovalPayload(item) {
      return {
        period_id: this.selectedPeriod,
        model_id: item.model_id,
        type: item.type,
        amount: this.parseAmountForSave(item.amount, item.currency),
        currency: item.currency,
        description: String(item.description || '').trim(),
        quotas: Number(item.quotas || 1),
        inventory_quantity: Math.max(1, Number(item.inventory_quantity || 1)),
        site: item.site,
      };
    },
    async approvePendingGroup(group) {
      const items = Array.isArray(group?.items) ? group.items : [];
      if (!items.length || !items.every((item) => this.canApprovePending(item))) return;

      if (items.every((item) => this.isStudioPending(item))) {
        this.openStudioUseDialog(items);
        return;
      }

      this.pendingActionId = items[0].id;
      try {
        const results = await this.approvePendingItems(items);
        if (!results.length) return;
        const approved = results.filter((result) => result.status === 'fulfilled').length;
        if (approved === items.length) {
          toast.success(items.length === 1 ? 'Report adjustment approved' : `${approved} report adjustments approved`);
        } else {
          toast.error(`${approved} of ${items.length} report adjustments were approved`);
        }
        await this.fetchModels();
      } catch (error) {
        console.error('Error approving pending adjustment group:', error?.message || error);
        toast.error('Failed to approve report adjustments');
        await this.fetchModels();
      } finally {
        this.pendingActionId = null;
      }
    },
    async dismissPendingGroup(group) {
      if (!this.canEdit) return;
      const items = Array.isArray(group?.items) ? group.items : [];
      if (!items.length || !window.confirm(`Dismiss ${items.length === 1 ? 'this report adjustment' : `these ${items.length} report adjustments`} without adding ${items.length === 1 ? 'it' : 'them'}?`)) return;

      this.pendingActionId = items[0].id;
      try {
        const results = await Promise.allSettled(items.map((item) =>
          secureAxios.post(`/api/adjustments/pending/${item.id}/dismiss`)
        ));
        const dismissedIds = new Set(items
          .filter((item, index) => results[index].status === 'fulfilled')
          .map((item) => item.id));
        this.pendingAdjustments = this.pendingAdjustments.filter((row) => !dismissedIds.has(row.id));
        if (dismissedIds.size === items.length) {
          toast.success(items.length === 1 ? 'Pending adjustment dismissed' : `${items.length} pending adjustments dismissed`);
        } else {
          toast.error(`${dismissedIds.size} of ${items.length} pending adjustments were dismissed`);
        }
      } catch (error) {
        console.error('Error dismissing pending adjustment group:', error?.message || error);
        toast.error('Failed to dismiss pending adjustments');
      } finally {
        this.pendingActionId = null;
      }
    },
    async approvePending(item) {
      if (!this.canApprovePending(item)) return;
      this.pendingActionId = item.id;
      try {
        const results = await this.approvePendingItems([item]);
        if (!results.length) return;
        if (results[0].status === 'rejected') throw results[0].reason;
        toast.success('Report adjustment approved');
        await this.fetchModels();
      } catch (error) {
        console.error('Error approving pending adjustment:', error?.message || error);
        toast.error(error?.response?.data || 'Failed to approve pending adjustment');
      } finally {
        this.pendingActionId = null;
      }
    },
    async dismissPending(item) {
      if (!this.canEdit) return;
      if (!window.confirm('Dismiss this report adjustment without adding it?')) return;
      this.pendingActionId = item.id;
      try {
        await secureAxios.post(`/api/adjustments/pending/${item.id}/dismiss`);
        this.pendingAdjustments = this.pendingAdjustments.filter((row) => row.id !== item.id);
        toast.success('Pending adjustment dismissed');
      } catch (error) {
        console.error('Error dismissing pending adjustment:', error?.message || error);
        toast.error(error?.response?.data || 'Failed to dismiss pending adjustment');
      } finally {
        this.pendingActionId = null;
      }
    },
    findModelIndex(id) {
      return this.models.findIndex(m => m.id === id);
    },
    async saveAdjustments(modelId, lateConfirmation = false) {
      if (this.isPeriodLocked) {
        toast.error('Period is locked, cannot save adjustments');
        return;
      }
      const index = this.findModelIndex(modelId);
      if (index === -1) return;

      const model = this.models[index];
      if (model?.isLocked) {
        toast.error('This model is locked for this period');
        return;
      }
      const unlinkedRecovery = model.adjustments.find((adjustment) => (
        adjustment.type === 'Discount'
        && !adjustment.card_expense_id
        && !adjustment.cash_box_entry_id
        && !adjustment.recovery_type
        && this.looksLikeRecoveryDescription(adjustment.description)
      ));
      if (unlinkedRecovery) {
        toast.warning('Select a Card or Cash Adelanto/Préstamo option from the Description list.');
        return;
      }
      const payload = {
        late_confirmation: lateConfirmation,
        period_id: this.selectedPeriod,
        classes: model.classes,
        subsidy: this.toDbSubsidy(model.subsidy),
        retention_status: model.retention_status,
        hours_override: model.location === 'Satellite' ? model.hours_override ?? null : null,
        percentage_override: model.location === 'Satellite' ? model.percentage_override ?? null : null,
        adjustments: model.adjustments.map(adj => ({
          id: adj.id,
          type: adj.type,
          amount: this.parseAmountForSave(adj.amount, adj.currency),
          currency: adj.currency,
          commission_percent: adj.commission_percent ?? null,
          description: adj.description,
          recovery_type: adj.recovery_type || null,
          recovery_source: adj.recovery_source || null,
          inventory_item_id: Number(adj.inventory_item_id) || null,
          inventory_quantity: Math.max(1, Number(adj.inventory_quantity || 1)),
          inventory_stock_applied: adj.inventory_stock_applied !== false,
          site: this.normalizeSiteValue(adj.site, model),
          number: adj.number,
          quotas: adj.quotas,
          date: this.dateToString(adj.date),
          observation: adj.observation || '',
          nextPeriod: adj.nextPeriod || false,
          insufficientFunds: adj.insufficientFunds || false
          ,card_expense_id: Number(adj.card_expense_id) || null
          ,cash_box_entry_id: Number(adj.cash_box_entry_id) || null
          ,payout_status: adj.payout_status || 'confirmed'
        }))
      };

      this.isSaving = true;

      try {
        const response = await secureAxios.put(`/api/adjustments/models/${modelId}`, payload);
        await this.fetchExportStatus();

        if (response?.data?.model_adjustment_id) {
          model.adjustments_id = response.data.model_adjustment_id;
        }

        if (Array.isArray(response?.data?.adjustments)) {
          this.rehydrateModelAdjustmentsFromSave(model, response.data.adjustments);
          this.hydrateAcceptedInventoryPricing();
        } else {
          model.adjustments.forEach(adj => {
            adj.isNew = false;
            adj.isEdited = false;
          });
        }

        const duplicatesSkipped = Number(response?.data?.duplicatesSkipped || 0);
        if (duplicatesSkipped > 0 || response?.data?.duplicate) {
          const label = duplicatesSkipped === 1 ? 'row' : 'rows';
          toast.warning(`Saved with ${duplicatesSkipped || 1} duplicate ${label} skipped.`);
        } else {
          toast.success(`Adjustments saved for ${model.stageName}`);
        }
        return true;
      } catch (error) {
        console.error('❌ Error saving adjustments:', error?.message || error);
        if (error.response?.data?.skippedCb) {
          const skipped = error.response.data;
          if (!skipped.destination) { toast.error(skipped.message); return false; }
          if (!window.confirm(skipped.message)) return false;
          const model = this.models.find(m => m.id === modelId);
          const ids = new Set(skipped.adjustment_ids);
          const rows = model.adjustments.filter(row => !row.nextPeriod && this.isCbSiteValue(row.site, model) && ids.has(Number(row.id) || null));
          for (const row of rows) {
            if (!await this.sendToNextPeriod(-1, model.adjustments.indexOf(row), skipped.destination, model, false)) return false;
          }
          return this.saveAdjustments(modelId, true);
        }
        if (error.response?.data?.lateAdjustment) {
          if (await this.showLateWarning(error.response.data.message) === 'current') return this.saveAdjustments(modelId, true);
          return false;
        }
        // If backend returns duplicate adjustment error (400/409), show user-friendly toast
        const errMsg = error?.response?.data?.message || error?.response?.data || error?.message || 'Unknown error';
        if (
          error?.response?.status === 409 &&
          error?.response?.data?.duplicate
        ) {
          toast.warning('Duplicate adjustment detected. Row was not saved.');
        } else if (
          typeof errMsg === 'string' &&
          errMsg.includes('Este ajuste ya existe')
        ) {
          toast.error('Este ajuste ya existe. Cambia la fecha o descripción para agregarlo.');
        } else {
          toast.error(`Error saving adjustments: ${errMsg}`);
        }
      } finally {
        this.isSaving = false;
      }
    },
    async saveAdjustment(modelId, adjIndex) {
      const index = this.findModelIndex(modelId);
      if (index === -1) return;
      await this.saveAdjustments(modelId);
    },
    markAdjustmentAsEdited(modelId, adjIndex) {
      const index = this.findModelIndex(modelId);
      if (index === -1) return;
      const adjustment = this.models[index].adjustments[adjIndex];
      if (!adjustment.isNew) {
        adjustment.isEdited = true;
      }
    },
    restrictToNumbers(event) {
      const allowedKeys = [8, 46, 37, 38, 39, 40];
      const charCode = event.charCode || event.keyCode;
      if (charCode !== 0 && !allowedKeys.includes(charCode) && (charCode < 48 || charCode > 57)) {
        event.preventDefault();
      }
    },
    async addAdjustment(modelIndex) {
      if (this.isPeriodLocked) {
        toast.error('Period is locked, cannot add adjustments');
        return;
      }
      if (this.filteredModels[modelIndex]?.isLocked) {
        toast.error('This model is locked for this period');
        return;
      }
      if (this.filteredModels[modelIndex].adjustments.length >= 30) {
        toast.error("Maximum of 30 adjustment lines reached for this model.");
        return;
      }
      
      const id = this.filteredModels[modelIndex].id;
      const index = this.findModelIndex(id);
      if (index === -1) return;

      const newAdjustment = {
        type: "Purchase",
        amount: '0',
        currency: "COP",
        description: "",
        inventory_item_id: null,
        inventory_unit_price: null,
        inventory_menu_open: false,
        recovery_menu_open: false,
        recovery_type: null,
        recovery_source: null,
        cash_box_entry_id: null,
        inventory_quantity: 1,
        inventory_stock_applied: true,
        site: this.getDefaultSiteForNewAdjustment(this.models[index]),
        number: 1,
        quotas: 1,
        date: new Date(),
        isNew: true,
        isEdited: false,
        nextPeriod: false,
        insufficientFunds: false,
        commission_percent: null
      };

      this.models[index].adjustments.push(newAdjustment);
    },
    searchAdjustments() {
      if (!this.searchKeyword) return;
      const matches = this.findModelsByAdjustmentDescription(this.searchKeyword);
      this.selectedModels = matches.map(m => m.fullName);
      this.activeTab = 'active';
    },
    normalizeSearchText(value) {
      return String(value || '')
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase();
    },
    getSearchTokens(value) {
      return this.normalizeSearchText(value).match(/[a-z0-9]+/g) || [];
    },
    adjustmentDescriptionMatches(description, searchValue) {
      const searchTokens = this.getSearchTokens(searchValue);
      if (searchTokens.length === 0) return false;

      const descriptionTokens = this.getSearchTokens(description);
      if (descriptionTokens.length === 0) return false;

      return searchTokens.every(searchToken =>
        descriptionTokens.some(descriptionToken => descriptionToken.startsWith(searchToken))
      );
    },
    findModelsByAdjustmentDescription(searchValue) {
      return this.models.filter(model =>
        model.adjustments?.some(adj => this.adjustmentDescriptionMatches(adj.description, searchValue))
      );
    },
    async fetchAvailableModels() {
      try {
        const response = await secureAxios.get('/api/adjustments/models/active', {
          params: { periodId: this.selectedPeriod }
        });
        this.availableModels = response.data.map(model => ({
          id: model.id,
          fullName: model.fullName,
          stageName: model.stageName
        }));
      } catch (error) {
        console.error('❌ Error fetching available models:', error?.message || error);
        toast.error('Failed to fetch available models');
      }
    },
    async selectModel(modelId) {
      if (this.isPeriodLocked) {
        toast.error('Period is locked, cannot add models');
        return;
      }
      const payload = {
        model_id: modelId,
        period_id: this.selectedPeriod,
        retention_status: 'No',
        subsidy: 'None'
      };
      try {
        await secureAxios.post('/api/adjustments/models', payload);
        toast.success(`Model ${modelId} added successfully`);
        this.dialog = false;
        this.searchQuery = '';
        await this.fetchModels();
      } catch (error) {
        console.error('❌ Error adding model:', error?.message || error);
        toast.error('Failed to add model');
      }
    },
    openActionDialog(modelIndex, adjIndex) {
      this.selectedModelIndex = modelIndex;
      this.selectedAdjIndex = adjIndex;
      const model = this.filteredModels[modelIndex];
      const adj = model.adjustments[adjIndex];
      this.editingAdjustment = JSON.parse(JSON.stringify(adj));
      this.actionDialog = true;
    },
    manageLinkedCardExpense(model, item) {
      this.$router.push({ path: '/card-expenses', query: { search: model?.fullName || '', entryId: item?.card_expense_id || undefined } });
    },
    manageLinkedCashBox(model, item) {
      this.$router.push({ path: '/cash-box', query: { search: model?.fullName || '', entryId: item?.cash_box_entry_id || undefined } });
    },
    async deleteLinkedRecovery(model, item) {
      const type = item?.recovery_type === 'Prestamo' ? 'Préstamo' : (item?.recovery_type || 'recovery');
      if (!window.confirm(`Delete this linked ${type} for ${model?.fullName}? It will be removed from both Adjustments and Card Expenses.`)) return;
      try {
        const { data } = await secureAxios.delete(`/api/card-expenses/${item.card_expense_id}`);
        toast.success(data.message);
        await this.fetchModels();
      } catch (error) {
        toast.error(error?.response?.data?.message || 'Unable to delete linked recovery');
      }
    },
    async fetchConfiguredSiteOptions() {
      try {
        const response = await secureAxios.get('/api/config/sites');
        const labelByKey = {
          flirt4free: 'F4F', streamate: 'SM', livejasmin: 'LJ',
          stripchat: 'SC', chaturbate: 'CB', kwiky: 'KWK',
          sinparty: 'SP', cams: 'CAMS', cam4: 'CAM4', bonga: 'BONGA'
        };
        this.siteOptions = (response.data?.sites || [])
          .filter(site => site.enabled)
          .map(site => ({ label: labelByKey[site.key] || site.displayName, value: site.name }));
      } catch (error) {
        console.error('Unable to load configured adjustment sites:', error?.message || error);
      }
    },
    removeAdjustment(modelIndex, adjIndex) {
      if (!(this.isAdmin || this.isSatelliteMonitor)) {
        toast.error('Only admins can remove adjustments');
        return;
      }
      if (this.isPeriodLocked) {
        toast.error('Period is locked, cannot remove adjustments');
        return;
      }
      const id = this.filteredModels[modelIndex].id;
      const index = this.findModelIndex(id);
      if (index === -1) return;

      this.models[index].adjustments.splice(adjIndex, 1);
      this.actionDialog = false;
      this.debounceSave(id);
    },
    async sendToNextPeriod(modelIndex, adjIndex, destination = null, sourceModel = null, saveSource = true) {
      if (this.isPeriodLocked) {
        toast.error('Period is locked, cannot modify adjustments');
        return;
      }
      const currentPeriodIndex = this.periods.findIndex(p => p.id === this.selectedPeriod);
      if (!destination && (currentPeriodIndex === -1 || currentPeriodIndex === this.periods.length - 1)) {
        toast.error('No next period available');
        this.actionDialog = false;
        return;
      }

      let nextPeriod = destination || this.periods[currentPeriodIndex + 1];
      const model = sourceModel || this.filteredModels[modelIndex];
      const index = this.findModelIndex(model.id);
      if (index === -1) return;

      const adj = { ...model.adjustments[adjIndex] };
      adj.date = this.dateToString(adj.date);
      adj.amount = this.parseAmountForSave(adj.amount, adj.currency);
      delete adj.id; // New adjustment in next period
      delete adj.isNew;
      delete adj.isEdited;
      delete adj.nextPeriod; // Reset for next period
      delete adj.insufficientFunds;
      const wasSaved = Boolean(model.adjustments[adjIndex].id);
      if (wasSaved) adj.inventory_stock_applied = false;

      try {
        if (this.isCbSiteValue(adj.site, model)) {
          const { data: skipped } = await secureAxios.get(`/api/adjustments/cb-destination/${nextPeriod.id}`);
          if (skipped) {
            if (!skipped.destination) throw new Error(skipped.message);
            if (!window.confirm(skipped.message)) return false;
            nextPeriod = skipped.destination;
          }
        }
        // Check if model exists in next period
        const response = await secureAxios.get('/api/adjustments/models', {
          params: { periodId: nextPeriod.id }
        });
        const nextModels = response.data.models;
        const match = nextModels.find(m => m.id === model.id);
        if (!match) {
          await secureAxios.post('/api/adjustments/models', {
            model_id: model.id,
            period_id: nextPeriod.id,
            classes: model.classes,
            subsidy: this.toDbSubsidy(model.subsidy)
          });
        }

        // Fetch existing adjustments to append
        const existingResponse = await secureAxios.get('/api/adjustments/models', {
          params: { periodId: nextPeriod.id }
        });
        const existingModel = existingResponse.data.models.find(m => m.id === model.id);
        const existingAdjustments = existingModel ? existingModel.adjustments : [];

        // Append new adjustment to next period
        await secureAxios.put(`/api/adjustments/models/${model.id}`, {
          period_id: nextPeriod.id,
          late_confirmation: true,
          classes: model.classes,
          subsidy: this.toDbSubsidy(model.subsidy),
          adjustments: [...existingAdjustments, adj]
        });

        // Mark as ghost row in current period
        if (wasSaved) this.models[index].adjustments[adjIndex].nextPeriod = true;
        else this.models[index].adjustments.splice(adjIndex, 1);
        if (saveSource && await this.saveAdjustments(model.id, true) !== true) {
          throw new Error('The next-period entry was created, but the source period could not be updated. Refresh and review both periods before retrying.');
        }
        toast.success(`Adjustment sent to next period: ${nextPeriod.name}`);
        this.actionDialog = false;
        return true;
      } catch (err) {
        console.error('❌ Error sending to next period:', err?.message || err);
        toast.error(err.response?.data?.message || err.response?.data || err.message || 'Failed to send adjustment to next period');
        this.actionDialog = false;
        return false;
      }
    },
    toggleInsufficientFunds(modelIndex, adjIndex) {
      const model = this.filteredModels[modelIndex];
      const index = this.findModelIndex(model.id);
      if (index === -1) return;
      const adjustment = this.models[index].adjustments[adjIndex];
      adjustment.insufficientFunds = !adjustment.insufficientFunds;
      this.debounceSave(model.id);
      this.actionDialog = false;
    },
    closeDialog() {
      if (this.isPeriodLocked) {
        this.actionDialog = false;
        this.editingAdjustment = {};
        return;
      }
      const model = this.filteredModels[this.selectedModelIndex];
      const index = this.findModelIndex(model.id);
      if (index !== -1 && this.models[index].adjustments[this.selectedAdjIndex]) {
        const currentObs = this.models[index].adjustments[this.selectedAdjIndex].observation;
        const newObs = this.editingAdjustment?.observation || '';
        if (currentObs !== newObs) {
          this.models[index].adjustments[this.selectedAdjIndex].observation = newObs;
          this.debounceSave(model.id); // Autosave observation
        }
      }
      this.actionDialog = false;
      this.editingAdjustment = {};
    },
    setActiveCard(card) {
      this.activeCard = card;
    },
    viewModel() {
      if (this.modelFilter && !this.selectedModels.includes(this.modelFilter)) {
        this.selectedModels.push(this.modelFilter);
        this.modelFilter = null;
      }
    },
    removeModelChip(modelName) {
      this.selectedModels = this.selectedModels.filter(name => name !== modelName);
    },
    viewPeriod() {
      this.fetchModels();
    },
    async goToPreviousPeriod() {
      if (!this.canGoToPreviousPeriod) return;
      this.selectedPeriod = this.periods[this.selectedPeriodIndex - 1].id;
      this.setActiveCard('period');
      await this.fetchModels();
    },
    async goToNextPeriod() {
      if (!this.canGoToNextPeriod) return;
      this.selectedPeriod = this.periods[this.selectedPeriodIndex + 1].id;
      this.setActiveCard('period');
      await this.fetchModels();
    },
    async saveExcelNotes() {
      if (!this.selectedPeriod || this.isPeriodLocked || !this.canEdit) return;

      try {
        await secureAxios.put('/api/adjustments/period-notes', {
          period_id: this.selectedPeriod,
          main_note: this.mainExcelNote,
          cb_note: this.cbExcelNote
        });
        return true;
      } catch (error) {
        console.error('❌ Error saving Excel notes:', error?.message || error);
        toast.error('Failed to save Excel notes');
        return false;
      }
    },
    toggleFilter(filter) {
      if (this.activeFilters.includes(filter)) {
        this.activeFilters = this.activeFilters.filter(f => f !== filter);
      } else {
        this.activeFilters.push(filter);
      }
    },
    sortModels(option) {
      this.sortOption = option;
      switch (option) {
        case 'Full Name A → Z':
          this.models.sort((a, b) => a.fullName.toLowerCase().localeCompare(b.fullName.toLowerCase()));
          break;
        case 'Full Name Z → A':
          this.models.sort((a, b) => b.fullName.toLowerCase().localeCompare(a.fullName.toLowerCase()));
          break;
        case 'Stage Name A → Z':
          this.models.sort((a, b) => a.stageName.toLowerCase().localeCompare(b.stageName.toLowerCase()));
          break;
        case 'Stage Name Z → A':
          this.models.sort((a, b) => b.stageName.toLowerCase().localeCompare(a.stageName.toLowerCase()));
          break;
      }
    },
    isSubsidyNone(value) {
      return String(value || 'None').trim().toLowerCase() === 'none';
    },
    shouldWarnNoSubsidies() {
      if (this.isSatelliteMonitor) return false;
      const exportModels = this.filteredModels.filter(model =>
        (model.status || '').toString().toUpperCase() === 'ACTIVE' || this.hasVisibleAdjustments(model)
      );

      if (exportModels.length === 0) return false;
      return exportModels.every(model => this.isSubsidyNone(model.subsidy));
    },
    cancelSubsidyWarning() {
      this.subsidyDownloadConfirm = {
        open: false,
        group: 'main'
      };
    },
    confirmDownloadWithoutSubsidies() {
      const group = this.subsidyDownloadConfirm.group || 'main';
      this.cancelSubsidyWarning();
      this.downloadAdjustments(group, { skipSubsidyWarning: true });
    },
    async downloadAdjustments(group = 'main', options = {}) {
      if (this.exportDownloading || this.isSaving) return;
      if (!options.skipSubsidyWarning && this.shouldWarnNoSubsidies()) {
        this.subsidyDownloadConfirm = {
          open: true,
          group
        };
        return;
      }

      this.exportDownloading = true;
      const periodId = this.selectedPeriod;
      try {
      if (!await this.flushQueuedSaves()) return;
      const status = await this.fetchExportStatus(periodId);
      if (this.models.some(model => model.adjustments.some(adj => adj.isNew || adj.isEdited))) {
        toast.warning('Save your edited adjustments before downloading.');
        return;
      }
      if (!await this.fetchModels() || Number(this.selectedPeriod) !== Number(periodId)) return;
      await this.$nextTick();
      const period = this.selectedPeriodRecord;
      const exportModels = JSON.parse(JSON.stringify(this.filteredModels));
      const fullExport = this.isFullGroupExport(exportModels);
      const periodName = period?.name || this.selectedPeriod || '';
      const exportLabel = group === 'cb' ? 'CB' : 'Main';
      const paymentDate = group === 'cb' ? period?.cb_payment_date : period?.payment_date;
      toast.info(`Downloading ${exportLabel} "${periodName}"${paymentDate ? ` - ${this.formatPeriodDateLabel(paymentDate)}` : ''}`);
      if (!this.$refs.adjustmentsExcel?.exportToXlsx) throw new Error('Excel exporter is unavailable');
      await this.$refs.adjustmentsExcel.exportToXlsx({
        models: exportModels,
        group,
        paymentDate,
        note: group === 'cb' ? this.cbExcelNote : this.mainExcelNote
      });
      if (!fullExport) { toast.info('Filtered Excel downloaded. The full-period download timestamp was not changed.'); return; }
      const { data } = await secureAxios.post(`/api/adjustments/export-status/${periodId}/download`, { group, revision: status[group].revision });
      if (Number(this.selectedPeriod) === Number(periodId)) this.exportStatus = data;
      } catch (error) { toast.error(error.response?.data?.message || error.message || 'Unable to download Excel'); }
      finally { this.exportDownloading = false; }
    },
  },
  watch: {
    activeTab() {
      if (this.modelFilter && !this.modelFilterOptions.some(model => model.fullName === this.modelFilter)) {
        this.modelFilter = null;
      }
    },
    'quotasEditor.total'(newTotal) {
      const total = Math.max(1, Number(newTotal) || 1);
      const current = Math.max(1, Number(this.quotasEditor.current) || 1);
      if (current > total) {
        this.quotasEditor.current = total;
      }
    },
    searchKeyword(newKeyword) {
      if (!newKeyword) {
        this.selectedModels = [];
        return;
      }
      const matches = this.findModelsByAdjustmentDescription(newKeyword);
      this.selectedModels = matches.map(m => m.fullName);
      this.activeTab = 'active';
    }
  },
  created() {
    this._adjustmentSaveDebouncers = new Map();
    this._excelNotesPending = false;
    this._excelNotesSaver = debounce(() => {
      this._excelNotesPending = false;
      return this.saveExcelNotes();
    }, 900);
  },
  beforeUnmount() {
    for (const save of this._adjustmentSaveDebouncers.values()) save.cancel();
    this._excelNotesSaver.cancel();
    this.resolveLateWarning('cancel');
  },
  mounted() {
    this.fetchConfiguredSiteOptions();
    this.fetchPeriods();
  }
};
</script>

<style scoped>
.excel-export-status { display: flex; flex-direction: column; margin-left: auto; gap: 2px; color: #64768a; font-size: 10px; white-space: nowrap; }
.excel-pending-stack {
  display: flex;
  flex-direction: column;
}

.excel-reports-block {
  order: 1;
}

.pending-adjustments-section {
  order: 2;
}

.pending-adjustments-section {
  margin-top: 18px;
  border: 1px solid #d8dde3;
  border-radius: 7px;
  background: #fff;
  overflow: hidden;
}

.pending-adjustments-header {
  display: flex;
  height: 48px;
  box-sizing: border-box;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 8px 16px;
  background: linear-gradient(180deg, #1c2321 0%, #3A4542 100%);
  border-bottom: 1px solid #303936;
}

.pending-adjustments-title {
  color: #fff;
  font-size: 18px;
  font-weight: 600;
}

.pending-adjustments-subtitle {
  margin-top: 2px;
  color: rgba(255, 255, 255, .72);
  font-size: 12px;
}

.pending-adjustments-empty {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 74px;
  color: #68717a;
  font-size: 14px;
}

.pending-adjustments-table-wrap {
  overflow-x: auto;
  padding: 0;
  background: #fff;
}

.pending-adjustments-table {
  width: 100%;
  min-width: 920px;
  border-collapse: separate;
  border-spacing: 0;
  table-layout: fixed;
}

.pending-adjustments-table th {
  padding: 3px 6px 2px;
  background: #fff;
  color: #707070;
  font-size: 12px;
  font-weight: 600;
  text-align: left;
}

.pending-column-row th {
  padding-top: 2px;
  padding-bottom: 4px;
  background: #fff;
  color: #707070;
  font-size: 12px;
  letter-spacing: normal;
  text-transform: none;
}

.pending-col-type { width: 12%; }
.pending-col-amount { width: 10%; }
.pending-col-currency { width: 9%; }
.pending-col-description { width: 33%; }
.pending-col-quantity { width: 6%; }
.pending-col-site { width: 8%; }
.pending-col-quotas { width: 7%; }
.pending-col-date { width: 10%; }
.pending-col-actions { width: 5%; }

.pending-adjustments-table td {
  padding: 0 2px;
  border-bottom: none;
  vertical-align: middle;
}

.pending-adjustment-card::before {
  display: table-row;
  height: 9px;
  content: '';
}

.pending-model-row td {
  padding: 10px 7px 3px;
  border-top: 1px solid #dfe3e7;
  border-right: 1px solid #dfe3e7;
  border-left: 3px solid #f4a621;
  border-radius: 6px 6px 0 0;
  background: #fff;
  box-shadow: 0 1px 3px rgba(31, 42, 52, .08);
}

.pending-model-identity {
  display: grid;
  grid-template-columns: minmax(280px, 33.333%) minmax(170px, 16.667%) 1fr 42px;
  align-items: center;
  gap: 8px;
}

.pending-identity-field {
  position: relative;
  min-width: 0;
  padding-top: 2px;
}

.pending-identity-field__label {
  position: absolute;
  top: -4px;
  left: 10px;
  z-index: 2;
  padding: 0 4px;
  background: #fff;
  color: #707070;
  font-size: 11px;
  line-height: 12px;
  pointer-events: none;
}

.pending-stage-name {
  min-width: 0;
}

.pending-review-note {
  position: relative;
  display: flex;
  min-width: 0;
  min-height: 40px;
  align-items: center;
  padding: 0 12px;
  border: 1px solid #c7cbd1;
  border-radius: 4px;
  background: #fff;
  color: #56616c;
  font-size: 15px;
  line-height: 1.25;
}

.pending-review-note__label {
  position: absolute;
  top: -7px;
  left: 10px;
  padding: 0 4px;
  background: #fff;
  color: #707070;
  font-size: 11px;
  line-height: 12px;
}

.pending-model-spacer {
  min-width: 0;
}

.pending-approve-btn,
.pending-action-btn {
  justify-self: center;
}

.direct-sales-section {
  margin: 16px 0 20px;
  border: 1px solid #dce3e8;
  border-radius: 6px;
  overflow: hidden;
  background: white;
}

.direct-sales-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 44px;
  padding: 5px 10px 5px 14px;
  background: linear-gradient(90deg, #17211f, #263532);
  color: white;
  font-size: 18px;
  font-weight: 700;
}

.direct-sales-body {
  padding: 8px;
}

.direct-sales-labels,
.direct-sale-row {
  display: grid;
  grid-template-columns: minmax(190px, 23fr) minmax(250px, 30fr) minmax(70px, 8fr) minmax(105px, 12fr) minmax(105px, 12fr) minmax(105px, 10fr) minmax(46px, 5fr);
  gap: 4px;
  align-items: center;
}

.direct-sales-labels {
  padding: 0 5px 3px;
  color: #68747f;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: .03em;
  text-transform: uppercase;
}

.direct-sale-row + .direct-sale-row {
  margin-top: 5px;
}

.direct-sale-actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 2px;
}

@media (max-width: 900px) {
  .direct-sales-labels { display: none; }
  .direct-sale-row { grid-template-columns: 1fr 1fr; gap: 8px; padding: 10px 4px; }
  .direct-sale-actions { justify-content: flex-start; }
}

.pending-fields-row {
  background: #fff;
}

.pending-column-row th:first-child,
.pending-fields-row td:first-child {
  border-left: 3px solid #f4a621;
}

.pending-column-row th:last-child,
.pending-fields-row td:last-child {
  border-right: 1px solid #dfe3e7;
}

.pending-fields-row + .pending-fields-row {
  border-top: none;
}

.pending-fields-row td {
  padding-top: 0;
  padding-bottom: 0;
}

.pending-fields-row--last td {
  border-bottom: 1px solid #dfe3e7;
  box-shadow: 0 2px 4px rgba(31, 42, 52, .08);
}

.pending-fields-row--last td:first-child {
  border-radius: 0 0 0 6px;
}

.pending-fields-row--last td:last-child {
  border-radius: 0 0 6px 0;
}

:deep(.pending-adjustments-table .v-input) {
  font-size: 14px;
}

:deep(.pending-adjustments-table .v-field) {
  min-height: 36px !important;
  height: 36px !important;
  background: #f4f4f4 !important;
}

:deep(.pending-identity-field .v-field) {
  min-height: 40px !important;
  height: 40px !important;
  background: #fff !important;
}

:deep(.pending-adjustments-table .pending-identity-field .v-field__input) {
  display: flex;
  min-height: 40px !important;
  align-items: center;
  padding-top: 0 !important;
  padding-bottom: 0 !important;
  font-size: 16px;
  font-weight: 700;
  line-height: 1.2;
}

:deep(.pending-adjustments-table .v-field__input) {
  min-height: 36px !important;
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}

:deep(.pending-amount-field input[type='number']) {
  appearance: textfield;
  -moz-appearance: textfield;
}

:deep(.pending-quantity-field input) {
  appearance: textfield;
  -moz-appearance: textfield;
  text-align: center;
  color: inherit;
}

:deep(.pending-quantity-field .v-field__input) {
  justify-content: center;
  padding-right: 8px !important;
  padding-left: 8px !important;
  text-align: center;
}

:deep(.pending-quantity-field .v-combobox__selection),
:deep(.pending-quantity-field .v-select__selection) {
  display: flex;
  flex: 1 1 auto;
  justify-content: center;
  margin-inline: 0;
  text-align: center;
}

:deep(.pending-quantity-field input[type='number']::-webkit-inner-spin-button),
:deep(.pending-quantity-field input[type='number']::-webkit-outer-spin-button) {
  margin: 0;
  -webkit-appearance: none;
}

.pending-quantity-cell {
  color: inherit;
  text-align: center;
}

:deep(.pending-amount-field input[type='number']::-webkit-inner-spin-button),
:deep(.pending-amount-field input[type='number']::-webkit-outer-spin-button) {
  margin: 0;
  -webkit-appearance: none;
}

.pending-report-source {
  color: #3f4f5f;
  font-size: 12px;
}

.pending-report-source strong,
.pending-report-source span {
  display: block;
}

.pending-original-name {
  margin-top: 0;
  color: #a15c00;
  font-size: 10px;
}

.pending-actions {
  white-space: nowrap;
  padding-top: 1px !important;
  text-align: center;
}

.pending-action-btn {
  border-color: #d8dde3 !important;
  background: #fff !important;
  color: #20272d !important;
  box-shadow: 0 1px 4px rgba(31, 42, 52, .14);
}

.active-card {
  border: 2px solid #1976d2 !important;
}

.download-period-btn {
  opacity: 1 !important;
}

.download-period-btn:hover {
  color: #1976d2 !important;
}

.download-period-btn:hover .v-icon {
  color: #1976d2 !important;
}

.adjustments-period-actions {
  justify-content: center;
  gap: 18px;
  margin-top: -16px;
  margin-bottom: 12px;
  position: absolute;
  bottom: 0;
  width: 100%;
}

.adjustments-period-arrow {
  background: #1976d2 !important;
  color: white !important;
  height: 36px !important;
  width: 44px !important;
}

.adjustments-period-arrow:disabled {
  background: #d8e1ec !important;
  color: #8391a3 !important;
}

.adjustments-period-arrow:deep(.v-icon) {
  color: white !important;
}

.adjustments-section-bar {
  align-items: center;
  background: linear-gradient(180deg, #1c2321 0%, #3A4542 100%);
  border-radius: 6px;
  color: white;
  display: flex;
  height: 48px;
  justify-content: space-between;
  margin-top: 16px;
  padding: 12px 16px;
}

.excel-notes-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 14px;
  margin-top: 12px;
}

.excel-note-card {
  border: 1px solid #dfe5ee;
  border-radius: 6px;
  padding: 12px;
  background: #ffffff;
}

.excel-note-card-main {
  --excel-accent: #1976d2;
  --excel-accent-soft: #eef6ff;
  --excel-accent-panel: #f4f8ff;
  --excel-due: #11824d;
}

.excel-note-card-cb {
  --excel-accent: #f59e0b;
  --excel-accent-soft: #fff7e6;
  --excel-accent-panel: #fffaf0;
  --excel-due: #d97706;
}

.excel-note-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 10px;
}

.excel-note-title-wrap {
  display: flex;
  align-items: center;
  gap: 12px;
}

.excel-note-avatar {
  align-items: center;
  background: var(--excel-accent-soft);
  border: 1px solid color-mix(in srgb, var(--excel-accent) 20%, transparent);
  border-radius: 50%;
  color: var(--excel-accent);
  display: inline-flex;
  flex: 0 0 auto;
  font-size: 14px;
  font-weight: 800;
  height: 36px;
  justify-content: center;
  width: 36px;
}

.excel-note-title {
  color: #1f2937;
  font-size: 18px;
  font-weight: 800;
  line-height: 1.2;
}

.excel-note-pending-chip {
  background: #fff7ed;
  border: 1px solid #fed7aa;
  border-radius: 999px;
  color: #c2410c;
  display: inline-flex;
  font-size: 11px;
  font-weight: 800;
  line-height: 1;
  padding: 5px 8px;
  white-space: nowrap;
}

.excel-note-summary-panel {
  align-items: center;
  background: var(--excel-accent-panel);
  border: 1px solid color-mix(in srgb, var(--excel-accent) 10%, #e5e7eb);
  border-radius: 6px;
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto minmax(0, 1fr);
  gap: 12px;
  margin-bottom: 10px;
  padding: 10px 12px;
}

.excel-note-summary-item {
  align-items: center;
  display: flex;
  gap: 10px;
  min-width: 0;
}

.excel-note-summary-icon {
  color: var(--excel-accent);
  flex: 0 0 auto;
}

.excel-note-summary-label {
  color: #667085;
  font-size: 11px;
  font-weight: 700;
  line-height: 1.2;
  margin-bottom: 3px;
}

.excel-note-summary-value {
  color: #111827;
  font-size: 14px;
  font-weight: 800;
  line-height: 1.2;
}

.excel-note-summary-divider {
  align-self: stretch;
  background: #d1d5db;
  width: 1px;
}

.excel-note-reminder {
  display: inline-flex;
  align-items: center;
  width: fit-content;
  padding: 3px 8px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 700;
}

.excel-note-due-value {
  color: var(--excel-due);
  font-size: 15px;
  font-weight: 900;
  line-height: 1.2;
}

.excel-note-due-value.is-due {
  color: #b45309;
}

.excel-note-due-value.is-completed {
  color: #166534;
}

.excel-note-due-value.is-muted {
  color: #6b7280;
}

.excel-note-due-date {
  color: #667085;
  font-size: 11px;
  font-weight: 700;
  margin-top: 1px;
}

.excel-note-divider {
  border-top: 1px solid #e5e7eb;
  margin: 0 0 8px;
}

.excel-note-label {
  align-items: center;
  color: #111827;
  display: flex;
  font-size: 14px;
  font-weight: 800;
  gap: 8px;
  margin-bottom: 0;
}

.excel-note-label .v-icon {
  color: var(--excel-accent);
}

.excel-note-inline {
  display: flex;
  align-items: center;
  gap: 10px;
}

.excel-note-inline .excel-note-label {
  flex: 0 0 auto;
}

.excel-note-inline :deep(.v-input) {
  flex: 1 1 auto;
  min-width: 0;
}

.excel-note-inline :deep(textarea) {
  overflow-x: hidden !important;
  overflow-y: auto !important;
  white-space: pre-wrap;
  overflow-wrap: anywhere;
}

.excel-note-action-stack {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 6px;
}

.excel-note-reminder.is-upcoming {
  color: #075985;
  background: #e0f2fe;
}

.excel-note-reminder.is-due {
  color: #92400e;
  background: #fef3c7;
}

.excel-note-reminder.is-completed {
  color: #166534;
  background: #dcfce7;
}

.excel-note-reminder.is-muted {
  color: #6b7280;
  background: #f3f4f6;
}

.excel-note-download {
  background: var(--excel-accent) !important;
  color: white !important;
  border-radius: 20px !important;
  text-transform: none;
  font-weight: 700;
}

.excel-note-download .v-icon {
  color: white !important;
}

@media (max-width: 900px) {
  .excel-notes-grid {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 640px) {
  .excel-note-summary-panel {
    grid-template-columns: 1fr;
  }

  .excel-note-summary-divider {
    display: none;
  }
}

/* Darken disabled fields/buttons slightly */
:deep(.v-field--disabled),
:deep(.v-btn--disabled),
:deep(.v-input--disabled) {
  opacity: 0.8; /* default feels ~0.38–0.5 */
}

/* Keep rows fully visible and avoid unnecessary inner scrolling. */
:deep(.adjustments-rows-table .v-table__wrapper) {
  overflow-y: hidden !important;
  padding-bottom: 3px;
}

:deep(.adjustments-rows-table table) {
  width: 100% !important;
  table-layout: fixed;
}

:deep(.adjustment-quantity-field .v-field__input) {
  justify-content: center;
  padding-right: 8px !important;
  padding-left: 8px !important;
  text-align: center;
}

:deep(.adjustment-quantity-field input),
:deep(.adjustment-quantity-field .v-combobox__selection),
:deep(.adjustment-quantity-field .v-select__selection) {
  text-align: center;
}

.studio-account-card {
  border-radius: 6px;
  margin-bottom: 16px;
  overflow: hidden;
}

.studio-account-header {
  align-items: center;
  background: #f7fafc;
  border-bottom: 1px solid #dce4ec;
  display: flex;
  justify-content: space-between;
  padding: 10px 14px;
}

.studio-account-actions {
  align-items: center;
  display: flex;
  gap: 8px;
}

.studio-account-title {
  color: #172b3a;
  font-size: 16px;
  font-weight: 800;
}

.studio-account-subtitle {
  color: #607384;
  font-size: 11px;
  margin-top: 1px;
}

.studio-account-table-wrap {
  overflow-x: auto;
}

.studio-account-table {
  border-collapse: collapse;
  table-layout: fixed;
  width: 100%;
}

.studio-account-table th,
.studio-account-table td {
  border-bottom: 1px solid #e4e9ee;
  padding: 8px 10px;
  text-align: left;
}

.studio-account-table th {
  color: #607384;
  font-size: 11px;
  font-weight: 700;
}

.studio-account-table td {
  color: #263746;
  font-size: 13px;
}

.studio-account-table th:nth-child(1) { width: 12%; }
.studio-account-table th:nth-child(2) { width: 29%; }
.studio-account-table th:nth-child(3) { width: 9%; }
.studio-account-table th:nth-child(4) { width: 8%; }
.studio-account-table th:nth-child(5) { width: 12%; }
.studio-account-table th:nth-child(6) { width: 20%; }
.studio-account-table th:nth-child(7) { width: 10%; }

.studio-account-empty {
  color: #718096;
  font-size: 13px;
  padding: 14px;
}

.studio-use-dialog-items {
  background: #f7fafc;
  border: 1px solid #dce4ec;
  border-radius: 6px;
  display: grid;
  gap: 5px;
  padding: 10px 12px;
}

</style>
   
